/**
 * Created by abdulhafeth on 3/28/16.
 */
import {
    BREAKS_TIME_PICKER_INTERVAL_PERIOD,
    JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD
} from "../../../../../hmodules/team-live/constants/date-picker-config.constants.js";

(function (angular, TeamScheduleAPI, ShiftsAPI) {
    "use strict";

    var emitter;
    var currentDay;
    var EVENTS = {
        SAVED: 'saved',
        CANCELED: 'canceled',
        DELETE: 'delete',
        RESTORE: 'restore',
        RESTORE_CONSENT: 'restore_consent',
        PUBLISH: 'publish'
    };

    function SaveShiftForm(scope, $modal, ScheduleDataServiceV2, ShiftTemplateUtils, TeamScheduleService, businessDayUtils, $q, $filter, TSUsersService, userServices, fairSchedulingService, goodFaithEstimateService, breaksManagementService, ScheduleCostsServiceV2, breaksAutoAssignService, ScheduleWarningServiceV2, jobTitlesDataService, ScheduleDifferentialPayService, hEvent, userPermissions, workVisasService, minorSchedulingService, useIncentiveOpenShiftPaymentFactory) {
        var self = this;
        var formName = "save-shift-form";
        var isOvernightShiftSettingsEnabled;
        var _protected = BaseForm.call(self, formName, scope);
        const jobTitlesFormData = {
            templateDataChanged: () => self.templateDataChanged(),
        }
        const _jobTitleFuncs = JobTitlesForm.call(self, jobTitlesDataService, jobTitlesFormData);
        emitter = JarEventEmitter.call(self);

        self.shiftBasedScheduling = false;
        self.loading = true;
        const SECONDS = 1;
        const MINUTE = 60 * SECONDS;
        const HOUR = 60 * MINUTE;

        const incentiveOpenShiftPayment = useIncentiveOpenShiftPaymentFactory();
        self.INCENTIVE_PAYMENT_TYPES = incentiveOpenShiftPayment.INCENTIVE_PAYMENT_TYPES;

        var unAssignedEmployee = {
            first_name: "Unassigned",
            name: $filter("translate")("Unassigned"),
            last_name: ""
        };

        let isShiftAssignmentAcrossDifferentPositionsEnabled;
        var publishedShift = null;

        var allPositions = {};
        var optedInEmployeesMap = {};

        //Class variables
        self.formData = {};

        self.onSaveShiftCanceled = function (handler) {
            self.on(EVENTS.CANCELED, handler);
        };

        self.onPublish = function (handler) {
            self.on(EVENTS.PUBLISH, handler);
        };

        self.onRestoreConsent = function (handler) {
            self.on(EVENTS.RESTORE_CONSENT, handler);
        };

        self.onRestore = function (handler) {
            self.on(EVENTS.RESTORE, handler);
        };

        self.selectRevenueCenter = function (revenueCenter) {
            self.data.revenue_center_id = revenueCenter.id;
            self.shiftStatus = 'UNPUBLISHED';
        };

        self.clearRevenueCenter = function () {
            if (self.data.revenue_center_id) {
                self.data.revenue_center_id = null;
                self.shiftStatus = 'UNPUBLISHED';
            }
        };

        self.clearLabels = function () {
            self.data.labels = null;
        };

        self.clearTemplate = function () {
            if (self.template) {
                self.template = null;
                self.shiftPaidBreaks = [];
                self.shiftUnpaidBreaks = [];
                self.shiftIntervals = [];
                self.shiftStatus = 'UNPUBLISHED';
                self.data.weight = 1;

                self.addInterval();
                if (self.data.job_titles) {
                    self.initJobTitles([]);
                }

                if (self.effectiveBreakEngine === "STATIC") {
                    self.addPaidBreak();
                    self.addUnpaidBreak();
                }
            }
        };

        self.onSaved = function (handler) {
            self.on(EVENTS.SAVED, handler);
        };

        self.onDelete = function (handler) {
            self.on(EVENTS.DELETE, handler);
        };

        self.unassign = function () {
            hEvent.track(self.formData.mode == 'EDIT' ? 'schedule_edit_shift_modal_unassign' : 'schedule_create_shift_modal_unassign', {
                'brand_id': self.formData.brand_id,
                'schedule_id': self.formData.schedule_id,
                'shift_id': (self.formData.mode == 'EDIT' && self.formData.shift.id) || null,
                'shift_status': 'UNASSIGNED',
                'user_with_approval': self.formData.canApproveAndPublish,
                'event_status': 'SUCCESS',
                'tag': 'schedule_creation',
            });
            self.formData.userChanged(null);
            self.data.employee = {...unAssignedEmployee};
            
            if (self.data.employee.id && self.enabledIncentiveSettings[self.INCENTIVE_PAYMENT_TYPES.RULE_BASED].shown) {
                self.data.incentiveDetails.incentiveRule = null;
            } else if (
                !self.data.employee?.id &&
                self.enabledIncentiveSettings[self.INCENTIVE_PAYMENT_TYPES.RULE_BASED].shown &&
                !incentiveOpenShiftPayment.checkIfRuleStillApplyToPosition(self.data.incentiveDetails?.incentiveRule, self.data.role?.category?.code, self.data.role?.code)
            ) {
                self.data.incentiveDetails.incentiveRule = incentiveOpenShiftPayment.getAutomaticAppliedRuleOnPosition(self.automaticeRulesMap, self.data.role?.category?.code, self.data.role?.code);
                self.onIncentiveRuleChange();
            }

            self.shiftStatus = 'UNPUBLISHED';
            self.showOptedInVSL = false;
            self.isHourlyEmployee = true;
            if (self.isAssigneeShiftForecastedRecurrenceEnabled) {
                self.showShiftRepeatOptions = true;
                self.data.forecasted_recurrence = 'ONCE';
            }
            if (self.isJobTitleSkillLevelServiceEnabled) {
                _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(self.data.employee.id);
            }
            prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);
            prepareEmployeeAvailabilitiesList(self.data.employee.id);
            self.checkMarkedDay(self.data.employee.id);
            checkIfAvailabilityConflicts();
            checkDifferentialPaymentWarning();
            checkIncentiveWarning();

            delete self.gfeUserIntervals;
            delete self.originalShiftDetails;
            delete self.user;
        };

        //if position cleared and template is selected clear all data include breaks
        //else prepare new breaks since some breaks rules depends on shift position
        self.clearPositions = function () {
            self.data.role = undefined;
            self.activeInceniveRules = [];
            self.employees = getEmployeesPositionGroups(self.positions);
            self.shiftStatus = 'UNPUBLISHED';

            if (self.template) {
                self.clearTemplate();
            } else {
                prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);
            }
            checkDifferentialPaymentWarning();
            checkIncentiveWarning();
        };

        self.clearShiftNote = function () {
            self.data.note.text = "";
            self.validator.validation['shift_note'] = self.validator.validation['shift_note'] || {};
            self.validator.validation['shift_note'].errors = {};
            self.shiftStatus = 'UNPUBLISHED';
        };

        var onDeleteShift = function (isRequestedByAssignee) {
            var shift = {
                user_id: self.data.employee.id,
                schedule_id: self.formData.schedule_id,
                position_code: self.data.role && self.data.role.code,
                role_day: self.formData.day,
                start_time: self.data.startTime,
                end_time: self.data.endTime,
                role_id: self.data.role && self.data.role.id,
                shift_id: self.formData.shift.id,
                assignee_id: self.data.employee.assignee_id,
                note: self.data.note,
                is_requested_by_assignee: isRequestedByAssignee
            };
            if (self.showShiftRepeatOptions) {
                shift['forecasted_recurrence'] = self.data.forecasted_recurrence;
            }
            self.isDeleting = true;

            emitter.trigger(EVENTS.DELETE, shift, isRequestedByAssignee);
        };

        //Delete shift
        self.deleteShift = function () {
            if (self.weekThresholdStatus === 'WITHIN_NOTICE' && self.isEmployeeConsentFlowEnabled && self.formData.employeeId && self.formData.shift.status === 'PUBLISHED') {
                var modalData = function () {
                    return {
                        onDelete: function (isRequestedByAssignee) {
                            onDeleteShift(isRequestedByAssignee);
                        }
                    };
                };

                $modal({
                    controller: 'ShiftDeleteConfirmationModalController',
                    controllerAs: '$ctrl',
                    templateUrl: '../modules/team_schedule/employer/schedule/modals/shift-delete-confirmation/shift-delete-confirmation.modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: modalData
                    }
                });
            } else {
                onDeleteShift(false);
            }
        };

        var isValidIntervals = function (intervals) {
            var isValidIntervals = true;

            for (var i in intervals) {
                var interval = intervals[i];

                if (!interval.start_time || !interval.end_time) {
                    isValidIntervals = false;
                    break;
                }
            }

            return isValidIntervals;
        };

        self.validator.validateCustom = function (field, optionsField, rule, showError) {
            var fieldIndex = optionsField.attr('validate-index');
            var value = self.validator.getFieldValue(field);

            switch (rule.name) {
                case "time":
                    return value && /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/.test(value);

                case "start_end_time":
                    if (field.attr("name") == "shift_start_time") {
                        if (self.data.endTime) {
                            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{start_time: field.val(), end_time: self.data.endTime}];
                            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                            var startTime = intervals[0].start_time;
                            var endTime = intervals[intervals.length - 1].end_time;
                            var shiftLength = Math.abs(startTime - endTime);
                            return shiftLength >= (15 * 60 * 1000);
                        }
                    } else {
                        if (self.data.startTime) {
                            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{start_time: self.data.startTime, end_time: field.val()}];
                            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                            var startTime = intervals[0].start_time;
                            var endTime = intervals[intervals.length - 1].end_time;
                            var shiftLength = Math.abs(startTime - endTime);
                            return shiftLength >= (15 * 60 * 1000);
                        }
                    }
                    break;
                case "shift-max-time":
                    if (self.shiftBasedScheduling && self.shiftIntervals[0]?.start_time && self.shiftIntervals[self.shiftIntervals.length - 1]?.end_time) {
                        const difference = moment(self.shiftIntervals[self.shiftIntervals.length - 1].end_time).diff(self.shiftIntervals[0].start_time, 'seconds');
                        if (difference > (24 * HOUR)) {
                            return false;
                        }
                    }
                    break;

                case "business_day":
                    if (self.data.startTime && self.data.endTime) {
                        var shiftInterval = {start_time: self.data.startTime, end_time: self.data.endTime};

                        return !!businessDayUtils.isWithinBusinessDay(shiftInterval, self.formData.day, false);
                    }

                    break;

                case "intervals-within-business-day":
                    if (
                        self.shiftIntervals[fieldIndex].start_time &&
                        self.shiftIntervals[fieldIndex].end_time &&
                        isValidIntervals(self.shiftIntervals)
                    ) {
                        var interval = businessDayUtils.normalizeTimeIntervals(self.shiftIntervals, ScheduleDataServiceV2.dayOpenHour)[fieldIndex];

                        if (interval) {
                            return !!businessDayUtils.isWithinBusinessDay(interval, self.formData.day, true);
                        }
                    }

                    break;

                case 'max-labels-count':
                    return (self.data.labels?.length || 0) <= 5;

                case "is-paid-break-within-shift-time":
                case "is-unpaid-break-within-shift-time":
                    var breakItem = rule.name === 'is-paid-break-within-shift-time' ? self.shiftPaidBreaks[fieldIndex] : self.shiftUnpaidBreaks[fieldIndex];
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{start_time: self.data.startTime, end_time: self.data.endTime}];

                    if (
                        breakItem.start_time &&
                        breakItem.end_time &&
                        isValidIntervals(shiftIntervals)
                    ) {
                        var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);

                        if (intervals) {
                            return !!ShiftTemplateUtils.isWithinShiftTime(intervals, breakItem);
                        }
                    }

                    break;

                case "is-paid-breaks-overlapped":
                case "is-unpaid-breaks-overlapped":
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{start_time: self.data.startTime, end_time: self.data.endTime}];
                    var paidBreaks = angular.copy(self.shiftPaidBreaks);
                    var unpaidBreaks = angular.copy(self.shiftUnpaidBreaks);
                    var breakItem;

                    if (rule.name === 'is-paid-breaks-overlapped') {
                        paidBreaks.splice(fieldIndex, 1);
                        breakItem = self.shiftPaidBreaks[fieldIndex];
                    } else {
                        unpaidBreaks.splice(fieldIndex, 1);
                        breakItem = self.shiftUnpaidBreaks[fieldIndex];
                    }

                    var allBreaks = paidBreaks.concat(unpaidBreaks);

                    if (
                        breakItem.start_time &&
                        breakItem.end_time &&
                        isValidIntervals(shiftIntervals)
                    ) {
                        var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                        return !ShiftTemplateUtils.isIntervalsOverlapped(intervals[0].start_time, breakItem, allBreaks);
                    }

                    break;

                case "required-if-one-set-job-title":
                    if (self.showJobTitleDrawManually()) {
                        return ;
                    }
                    var jobTitleItem = self.data.job_titles[fieldIndex];
                    var isValueSet = _jobTitleFuncs.isJobTitleStartAndEndTimeSet(jobTitleItem, field.attr("name"));
                    if (!isValueSet) {
                        return false;
                    }
                    break;

                case "is-job-title-within-shift-time":
                    if (self.showJobTitleDrawManually()) {
                        return;
                    }
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                        start_time: self.data.startTime,
                        end_time: self.data.endTime
                    }];
                    var jobTitleItem = self.data.job_titles[fieldIndex];

                    if (
                        jobTitleItem.start_time &&
                        jobTitleItem.end_time &&
                        isValidIntervals(shiftIntervals)
                    ) {
                        var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                        if (intervals) {
                            return !!ShiftTemplateUtils.isWithinShiftTime(intervals, jobTitleItem);
                        }
                    }

                    break;

                case "is-job-title-overlapped":
                    if (self.showJobTitleDrawManually()) {
                        return ;
                    }
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                        start_time: self.data.startTime,
                        end_time: self.data.endTime
                    }];
                    var jobTitles = angular.copy(self.data.job_titles).filter(function (jt, index) {
                        return index != fieldIndex && jt.start_time && jt.end_time;
                    });
                    var jobTitleItem = self.data.job_titles[fieldIndex];

                    if (
                        jobTitleItem.start_time &&
                        jobTitleItem.end_time &&
                        isValidIntervals(shiftIntervals)
                    ) {
                        var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                        return !ShiftTemplateUtils.isIntervalsOverlapped(intervals[0].start_time, jobTitleItem, jobTitles);
                    }

                    break;

                case 'set-start-and-end-time':
                    var jobTitlesList = jobTitlesDataService.getFormattedJobTitles();
                    for (var i in jobTitlesList) {
                        var jobTitleItem = jobTitlesList[i];
                        if (!jobTitleItem.end_time || !jobTitleItem.start_time) {
                            return false;
                        }
                    }
                    break;

                case "shift-has-stations-gap":
                    var jobTitlesList = [];
                    if (self.showJobTitleDrawManually()) {
                        jobTitlesList = jobTitlesDataService.getFormattedJobTitles();
                    }
                    else {
                        jobTitlesList =  self.data.job_titles;
                    }
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                        start_time: self.data.startTime,
                        end_time: self.data.endTime
                    }];
                    if (jobTitlesList.length) {
                        if (isValidIntervals(jobTitlesList) && isValidIntervals(shiftIntervals)) {
                            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                            var normalizedJobTitles = ShiftTemplateUtils.normalizeIntervalsWithShiftTime(intervals[0].start_time, jobTitlesList);
                            for (var j in intervals) {
                                var interval = intervals[j];
                                var intervalHasGap = ShiftTemplateUtils.hasStationsGap(interval, normalizedJobTitles);
                                if (intervalHasGap) {
                                    return false;
                                }
                            }
                            return true;
                        }
                    }
                    break;
                case "is-job-titles-in-schedule-overlapped":
                    if (!self.showJobTitleDrawManually()) {
                        return;
                    }
                    var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                        start_time: self.data.startTime,
                        end_time: self.data.endTime
                    }];
                    var dataToCheck = jobTitlesDataService.getFormattedJobTitles();

                    for (var fieldIndex = 0 ; fieldIndex < dataToCheck.length; fieldIndex++) {
                        var jobTitleItem = dataToCheck[fieldIndex];
                        var jobTitles = angular.copy(dataToCheck).filter(function (jt, index) {
                            return index != fieldIndex && jt.start_time && jt.end_time;
                        });
                        if (
                            jobTitleItem.start_time &&
                            jobTitleItem.end_time &&
                            isValidIntervals(shiftIntervals)
                        ) {
                            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                            var isIntervalsOverlapped = ShiftTemplateUtils.isIntervalsOverlapped(intervals[0].start_time, jobTitleItem, jobTitles);
                            if (isIntervalsOverlapped) {
                                return false;
                            }
                        }
                    }
                    break;

                case 'eligible-job-title':
                    if (self.showJobTitleDrawManually()) {
                        return;
                    }
                    var jobTitleItem = self.data.job_titles[fieldIndex];

                    if (self.data.role) {
                        return !_jobTitleFuncs.isJobTitleNotEligible(jobTitleItem.id, [self.data.role]);
                    }
                    break;
            }

            return true;
        };

        self.showPublishButton = function () {
            return (
                (
                    (self.shiftStatus !== 'PUBLISHED' && self.formData.isLocked) ||
                    self.shiftStatus === 'DELETED'
                ) &&
                self.formData.canPublish &&
                !self.approvalWorkflowEnabled &&
                !self.isExtendedFromPreviousDay &&
                !self.hasPendingEmployeeConsent
            );
        };

        self.showIsRequestedByAssigneeToggle = function () {
            return (
                self.isEmployeeConsentFlowEnabled &&
                self.data.employee?.id &&
                (
                    self.hasPendingEmployeeConsent ||
                    !publishedShift ||
                    checkIfShiftTimeChanged()
                ));
        };

        self.showSaveAndPublishButton = function () {
            return (
                self.shiftStatus !== 'PUBLISHED' &&
                self.shiftStatus !== 'DELETED' &&
                !self.formData.isLocked &&
                self.formData.canPublish &&
                !self.approvalWorkflowEnabled &&
                self.checkUserSchedulableStatus() !== 'NONE' &&
                !self.hasPendingEmployeeConsent
            );
        };

        self.showExtendedShiftIcon = function () {
            var showExceedBusinessDayWarning = checkEndTimeExceedBusinessDayWarning();

            return (
                showExceedBusinessDayWarning &&
                !self.isExtendedFromPreviousDay
            );
        };

        self.templateDataChanged = function () {
            self.template = null;
        };

        var save = function (publish, isRequestedByAssignee) {
            var shift = {
                user_id: self.data.employee.id,
                schedule_id: self.formData.schedule_id,
                position_code: self.data.role.code,
                role_day: self.formData.day,
                labels: self.data.labels,
                revenue_center_id: self.data.revenue_center_id,
                start_time: self.data.startTime,
                end_time: self.data.endTime,
                role_id: self.data.role.id,
                shift_id: self.formData.shift.id,
                assignee_id: self.data.employee.assignee_id,
                mode: self.formData.mode,
                weight: self.data.weight,
                note: self.data.note,
                code: self.template && self.template.code,
                is_requested_by_assignee: isRequestedByAssignee ? isRequestedByAssignee : (self.showIsRequestedByAssigneeToggle() ? !!self.isRequestedByAssignee : false)
            };

            if ((self.data.incentiveDetails?.incentiveRule || self.data.incentiveDetails?.fixedIncentive) && self.isHourlyEmployee) {
                if (!incentiveOpenShiftPayment.checkIfRuleStillApplyToPosition(self.data.incentiveDetails?.incentiveRule, self.data.role?.category?.code, self.data.role?.code)) {
                    self.data.incentiveDetails.incentiveRule = null;
                }
                shift.incentive_payments = incentiveOpenShiftPayment.parseShiftIncentiveForSave(self.data.incentiveDetails);
            }

            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals: [{ start_time: self.data.startTime, end_time: self.data.endTime }];
            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
            var preparedBreaks = ShiftTemplateUtils.getTimeBreaksObj(intervals, true);
            var excludeBreaksFromRequest;

            var period = ShiftTemplateUtils.getPeriod(preparedBreaks["start_time"], preparedBreaks["end_time"], self.formData.day);
            self.data.startTime = period.start;
            self.data.endTime = period.end;

            if (self.shiftBasedScheduling && self.template && self.template.code) {
                var template = ScheduleDataServiceV2.shiftsTemplates && ScheduleDataServiceV2.shiftsTemplates[self.template.code];
                excludeBreaksFromRequest = !self.isScheduledBreaksEnabled && template.id;
            }
            if (!excludeBreaksFromRequest) {
// prepare breaks from paid breaks, unpaid and intervals [split_shift] if shift template enabled
                self.shiftUnpaidBreaks = self.shiftUnpaidBreaks || [];
                self.shiftPaidBreaks = self.shiftPaidBreaks || [];
                shift.breaks = [];
                var breaks = self.shiftPaidBreaks.concat(self.shiftUnpaidBreaks);
                let hasAtLeastOneScheduledBreak = breaks.findIndex(function (breakItem) { return breakItem['start_time'] }) > -1;

                for (var i in breaks) {
                    var shiftBreak = angular.copy(breaks[i]);

                    if (
                        (self.effectiveBreakEngine === 'STATIC' && shiftBreak["duration"]) ||
                        (self.effectiveBreakEngine === 'DYNAMIC' && hasAtLeastOneScheduledBreak)
                    ) {
                        var breakItem = {
                            duration: parseInt(shiftBreak.duration * 60),
                            type: shiftBreak.type || shiftBreak.payment_type
                        };

                        if (self.isScheduledBreaksEnabled && shiftBreak["start_time"]) {
                            breakItem["start_time"] = ShiftTemplateUtils.timeObjToSeconds(shiftBreak['start_time']).hours +
                                ShiftTemplateUtils.timeObjToSeconds(shiftBreak['start_time']).minutes;

                            if (breakItem["start_time"] < preparedBreaks["start_time"]) {
                                breakItem["start_time"] += 24 * 60 * 60;
                            }
                        }

                        if (self.effectiveBreakEngine === 'DYNAMIC' && shiftBreak.category) {
                            breakItem["category"] = shiftBreak.category;
                        }

                        if (shiftBreak.id) {
                            breakItem["id"] = shiftBreak.id;
                        }

                        shift.breaks.push(breakItem);
                    }
                }

                if (preparedBreaks.breaks && preparedBreaks.breaks.length) {
                    shift.breaks = shift.breaks.concat(preparedBreaks.breaks);
                }
            }
            if (self.isJobTitleSkillLevelServiceEnabled) {
                shift.job_titles = [];
                var dataToSave = [];

                if (self.showJobTitleDrawManually()) {
                     dataToSave = angular.copy(jobTitlesDataService.getFormattedJobTitles());
                }
                else {
                  dataToSave = self.data.job_titles;
                }
                if (dataToSave && dataToSave.length) {
                    for (var j in dataToSave) {
                        var jobTitle = dataToSave[j];
                        var jobTitleObject = ShiftTemplateUtils.getIntervalTime(intervals[0].start_time, jobTitle);
                        var period = ShiftTemplateUtils.getPeriod(jobTitleObject.start_time / 1000, jobTitleObject.end_time / 1000, self.formData.day);
                        shift.job_titles.push({
                            job_title_id: jobTitle.jobTitle.id,
                            type: j == 0 ? "PRIMARY" : "SECONDARY",
                            start_time: jobTitle.start_time ? moment(period.start).format('YYYY-MM-DDTHH:mm:ss') : null,
                            end_time: jobTitle.end_time ? moment(period.end).format('YYYY-MM-DDTHH:mm:ss') : null,
                        });
                    }
                }
            }

            shift.start_time = self.data.startTime;
            shift.end_time = self.data.endTime;
            if (self.showShiftRepeatOptions) {
                shift['forecasted_recurrence'] = self.data.forecasted_recurrence;
            }

            emitter.trigger(EVENTS.SAVED, shift, publish);
            self.saving = true;

        };

        /**
         * validate the form and trigger save
         */
        self.save = function (publish) {
            var isValid = self.validator.validate() && !self.exceedMaxBreaksTime;

            if (isValid) {
                if (self.isNewlyHiredForWeek && publish) {
                    var userName = self.data.employee.first_name + " " + self.data.employee.last_name;

                    hConfirm({
                        title: $filter("translate")("Publishing initial week"),
                        text: userName + " " + $filter("translate")("is a newly hired employee and their initial week publishing will not trigger shift addition premium penalties, once you publish this shift any change for this employee’s week schedule will trigger premium penalties."),
                        confirmButton: $filter("translate")("Publish"),
                        callback: function (confirmed) {
                            if (confirmed) {
                                save(publish);
                            }
                        }
                    });
                } else {
                    if (
                        self.weekThresholdStatus === 'WITHIN_NOTICE' &&
                        self.isEmployeeConsentFlowEnabled &&
                        self.formData.employeeId &&
                        self.data.employee.id !== self.formData.employeeId &&
                        self.formData.shift.status === 'PUBLISHED'
                    ) {
                        var modalData = function () {
                            return {
                                onDelete: function (isRequestedByAssignee) {
                                    save(publish, isRequestedByAssignee);
                                }
                            };
                        };

                        $modal({
                            controller: 'ShiftDeleteConfirmationModalController',
                            controllerAs: '$ctrl',
                            templateUrl: '../modules/team_schedule/employer/schedule/modals/shift-delete-confirmation/shift-delete-confirmation.modal.html',
                            show: true,
                            backdrop: 'static',
                            resolve: {
                                modalData: modalData
                            }
                        });
                    }else {
                        save(publish);
                    }
                }
            }
        };

        self.publish = function () {
            if (self.isNewlyHiredForWeek) {
                var userName = self.data.employee.first_name + " " + self.data.employee.last_name;

                hConfirm({
                    title: $filter("translate")("Publishing initial week"),
                    text: userName + " " + $filter("translate")("is a newly hired employee and their initial week publishing will not trigger shift addition premium penalties, once you publish this shift any change for this employee’s week schedule will trigger premium penalties."),
                    confirmButton: $filter("translate")("Publish"),
                    callback: function (confirmed) {
                        if (confirmed) {
                            self.saving = true;
                            emitter.trigger(EVENTS.PUBLISH);
                        }
                    }
                });
            } else {
                self.saving = true;
                emitter.trigger(EVENTS.PUBLISH);
            }
        };

        self.restoreShift = function () {
            self.saving = true;
            emitter.trigger(EVENTS.RESTORE);
        };

        self.recalculateBreaks = function () {
            self.shiftPaidBreaks = [];
            self.shiftUnpaidBreaks = [];
            self.isRecalculateBreaksNeeded = false;
            prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);
        };

        var getRoleEmployees = function () {
            var defered = $q.defer();
            var usersToLoad = (!self.formData.employeeId || TSUsersService.users[self.formData.employeeId])? []: [self.formData.employeeId];
            var promises = {
                'brandUsers': TSUsersService.getBrandTeamUsers(self.brand.id, false, TSUsersService.EMPLOYEE_VIEW_STATUS.ACTIVE, TSUsersService.SCHEDULABLE.REGULAR)
            };

            if (usersToLoad.length) {
                promises['employee'] = TSUsersService.loadUsers(self.brand.id, usersToLoad);
            }

            $q.all(promises)
                .then(function(res) {
                    var brandUsers = res['brandUsers'];

                    if (self.formData.employeeId && !brandUsers[self.formData.employeeId]) {
                        brandUsers[self.formData.employeeId] = TSUsersService.users[self.formData.employeeId];
                    }

                    self.originalEmployees = Object.values(brandUsers);
                    self.originalEmployees = self.originalEmployees.sort((employeeA, employeeB) => {
                        return employeeA.name.toLowerCase().localeCompare(employeeB.name.toLowerCase());
                    });
                    self.positions = {"all": self.originalEmployees};

                    for (var index in self.originalEmployees) {
                        var employee = self.originalEmployees[index];
                        employee.name = employee.first_name + " " + employee.last_name;
                        if (self.formData.assigneeId) {
                            if (self.formData.employeeId == employee.id) {
                                employee.assignee_id = self.formData.assigneeId;
                            }
                        }
                        for (var i in employee.positions) {
                            var position = employee.positions[i];
                            self.positions[position.code] = self.positions[position.code] || [];
                            self.positions[position.code].push(employee);
                            allPositions[position.code] = position;
                        }
                    }

                    unAssignedEmployee.positions = unAssignedEmployee.positions || [];
                    unAssignedEmployee.assignee_id = self.formData.assigneeId;

                    // Apply filter unassigned employee positions if category is set, and in create for unassigned shift.
                    var editMode = self.formData.shift && self.formData.shift.id;
                    var filterUnassignedByCategory = self.formData.category && !editMode && !self.formData.shift.user_id;
                    var viewPositionsCodes = [];

                    if (self.activeScheduleView && self.activeScheduleView.id !== "MAIN") {
                        var viewPositions = self.activeScheduleView['positions'];
                        viewPositionsCodes = _.pluck(viewPositions, "code");
                    }

                    for (var index in allPositions) {
                        var position = allPositions[index];

                        if (!filterUnassignedByCategory || self.formData.category.toLowerCase() === position.category.code.toLowerCase()) {
                            if (viewPositionsCodes.length && viewPositionsCodes.indexOf(position.code) === -1) {
                                continue;
                            }

                            unAssignedEmployee.positions.push(position);
                        }
                    }

                    self.employees = getEmployeesPositionGroups(self.positions);

                    defered.resolve();

                });

            return defered.promise;
        };

        var getPositionTemplates = function (positionCode) {
            var shiftsTemplates = [];

            if (ScheduleDataServiceV2.shiftsTemplatesArray) {
                for (var key in ScheduleDataServiceV2.shiftsTemplatesArray) {
                    var template = ScheduleDataServiceV2.shiftsTemplatesArray[key];

                    for (var i in template.positions) {
                        var position = template.positions[i];

                        if (position.code === positionCode) {
                            shiftsTemplates.push(template);
                            break;
                        }
                    }
                }
            }

            return shiftsTemplates;
        };

        self.showShiftChangesPremiumsMessage = function () {
            return (
                !self.isNewlyHiredEmployee &&
                self.isFairSchedulingServiceEnabled &&
                self.weekThresholdStatus === 'WITHIN_NOTICE' &&
                self.shiftStatus !== 'DELETED' &&
                self.data.employee &&
                self.data.employee.id
            );
        };

        self.checkMarkedDay = function (userId) {
            if (ScheduleDataServiceV2.markedOffDays && ScheduleDataServiceV2.markedOffDays[userId]) {
                var markedDay = ScheduleDataServiceV2.markedOffDays[userId].find(function (day) {
                    return (
                        moment(day.date).isSame(moment(self.formData.day), 'day') ||
                        moment(day.date).isSame(moment(self.data.startTime), 'day') ||
                        moment(day.date).isSame(moment(self.data.endTime), 'day')
                    );
                });
                if (markedDay) {
                    self.markedAs = markedDay.markAs.toLowerCase() || markedDay.type.toLowerCase();
                    self.markedDay = moment(markedDay.date).format('dddd');
                }
            }
        }

        self.checkDateWithinActiveOrScheduledLocationPeriod = function () {
            self.nowInBrandTimezone = self.brand && moment(Utils.getNowInBrandTimezoneByTimeZoneName(self.brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
            return self.user? self.user.isDateWithinActiveOrScheduledLocationPeriod(self.formData.day, self.nowInBrandTimezone) : true;
        };

        self.checkDateWithinEmploymentPeriod = function () {
            return self.user? self.user.isDateWithinEmploymentPeriod(self.formData.day) : true;
        };

        self.checkDateWithinLoaPeriod = function () {
            return self.user ? TeamScheduleService.isLoaEnabled(self.brand) && self.user.hasEffectiveLOA(self.formData.day, true) : false;
        };

        self.checkUserSchedulableStatus = function () {
            return self.user? self.user['schedulable'] : TSUsersService.SCHEDULABLE.REGULAR;
        };

        self.isNextDayWithinEmploymentPeriod = function () {
            var isNextDayWithinEmploymentPeriod = true;

            if (self.user && self.showExtendedShiftIcon()) {
                var nextDate = moment(self.formData.day).clone().add(1, 'days');

                isNextDayWithinEmploymentPeriod = isNextDayWithinEmploymentPeriod && self.user.isDateWithinEmploymentPeriod(nextDate);
            }

            return isNextDayWithinEmploymentPeriod;
        };

        self.isNextDayWithinLocationPeriod = function () {
            var isNextDayWithinLocationPeriod = true;

            if (self.user && self.showExtendedShiftIcon()) {
                var nextDate = moment(self.formData.day).clone().add(1, 'days');

                isNextDayWithinLocationPeriod = isNextDayWithinLocationPeriod && self.user.isDateWithinActiveLocationPeriod(nextDate);
            }

            return isNextDayWithinLocationPeriod;
        };

        var isShiftFieldsDisabled = function () {
            return (
                self.formData.isLocked ||
                self.shiftStatus === 'DELETED' ||
                self.isRecalculateBreaksNeeded ||
                self.isExtendedFromPreviousDay ||
                self.checkUserSchedulableStatus() === 'NONE' ||
                !self.checkDateWithinActiveOrScheduledLocationPeriod() ||
                self.hasPendingEmployeeConsent
            );
        };

        self.showUnassign = function () {
            return !isShiftFieldsDisabled();
        };

        self.isShiftFieldsDisabled = function () {
            return (
                isShiftFieldsDisabled() ||
                !self.checkDateWithinEmploymentPeriod()
            );
        };

        self.isShiftTemplateOptionDisabled = function () {
            return (
                self.isShiftFieldsDisabled() ||
                !self.data.role
            );
        };

        self.isRestoreDisabled = function () {
            return (
                self.formData.isLocked ||
                !self.checkDateWithinEmploymentPeriod() ||
                !self.checkDateWithinActiveOrScheduledLocationPeriod() ||
                self.saving ||
                !self.isNextDayWithinEmploymentPeriod() ||
                !self.isNextDayWithinLocationPeriod()
            );
        };

        self.isSaveAndPublishDisabled = function () {
            return (
                self.saving ||
                self.isRecalculateBreaksNeeded ||
                self.isExtendedFromPreviousDay ||
                !self.checkDateWithinEmploymentPeriod() ||
                !self.checkDateWithinActiveOrScheduledLocationPeriod() ||
                !self.isNextDayWithinEmploymentPeriod() ||
                (self.user && self.user.schedulable == 'NONE') ||
                !self.isNextDayWithinLocationPeriod() ||
                self.checkDateWithinLoaPeriod() ||
                self.hasPendingEmployeeConsent
            )
        };

        self.isSaveDisabled = function () {
            return (
                self.formData.isLocked ||
                self.saving ||
                self.isRecalculateBreaksNeeded ||
                self.isExtendedFromPreviousDay ||
                !self.checkDateWithinEmploymentPeriod() ||
                !self.checkDateWithinActiveOrScheduledLocationPeriod() ||
                !self.isNextDayWithinEmploymentPeriod() ||
                (self.user && self.user.schedulable == 'NONE') ||
                !self.isNextDayWithinLocationPeriod() ||
                self.checkDateWithinLoaPeriod() ||
                self.hasPendingEmployeeConsent
            );
        };

        self.showJobTitleLevelsWarning = function () {
            if (self.isJobTitleSkillLevelServiceEnabled) {
                var allJobTitlesWithLevels = true;
                var dataToCheck = self.showJobTitleDrawManually() ? self.selectedJobTitles : self.data.job_titles;
                self.skillsLevelHaveWarnings = [];

                if (dataToCheck) {
                    for (var i in dataToCheck) {
                        var jobTitleLevel = (dataToCheck[i].jobTitle && dataToCheck[i].jobTitle.level) || (self.showJobTitleDrawManually() &&  dataToCheck[i].level);
                        allJobTitlesWithLevels = allJobTitlesWithLevels && !!jobTitleLevel;
                        if ([4, 5].indexOf(jobTitleLevel) > -1) {
                            if (self.skillsLevelHaveWarnings.indexOf(jobTitleLevel) === -1) {
                                self.skillsLevelHaveWarnings.push(jobTitleLevel);
                            }
                        }
                    }
                    self.skillsLevelHaveWarnings.sort(function(a, b){return a-b});
                }
                self.showShiftUndefinedJobTitleLevelsWarning = ScheduleWarningServiceV2.checkIfWarningEnabled(ScheduleWarningServiceV2.WARNING_SUB_CATEGORIES.UNDEFINED_JOB_TITLE_LEVEL.code) && !allJobTitlesWithLevels && self.data.employee && self.data.employee.id;
                self.showShiftAssignedJobTitleLevelsWarning = ScheduleWarningServiceV2.checkIfWarningEnabled(ScheduleWarningServiceV2.WARNING_SUB_CATEGORIES.SKILL_LEVEL_4_OR_5.code) && !!self.skillsLevelHaveWarnings.length && self.data.employee && self.data.employee.id;
                return self.showShiftUndefinedJobTitleLevelsWarning || self.showShiftAssignedJobTitleLevelsWarning;

            } else {
                return false;
            }
        };

        var checkFairSchedulingWeekThreshold = function (brandSettings, shiftDay) {
            self.weekThresholdStatus;
            var fairScheduleSettings = brandSettings['fair_work_week_settings'] && brandSettings['fair_work_week_settings']['penalty_settings'] || [];
            var shiftDate = moment(shiftDay, 'MMM DD, YYYY');

            if (self.isFairSchedulingServiceEnabled) {
                var fairSchedulingWeekStatus = fairSchedulingService.checkFairSchedulingWeekThresholdStatus(fairScheduleSettings, {from: shiftDate, to: shiftDate}, true);
                self.weekThresholdStatus = fairSchedulingWeekStatus['weekThresholdStatus'];
            }
        };


        self.handleOfferedToText = function () {
            var offeredToText = self.offeredToList.length;

            if (self.offeredToList.length === 1) {
                offeredToText += ' Employee'
            } else {
                offeredToText += ' Employees'
            }

            return offeredToText;
        };

        var prepareUserGFEIntervalsForDay = function (userId, day) {
            if (self.goodFaithEstimateUsers && !isNaN(userId)) {
                var userGFE = _.findWhere(self.goodFaithEstimateUsers, {id: parseInt(userId)});

                if (userGFE && moment(day).isSameOrAfter(userGFE['effective_start_date'])) {
                    var dayAbbr = moment(day).format('ddd').toUpperCase();
                    var gfeUserIntervals = _.filter(userGFE['intervals'], function (interval) {
                        return interval.day === dayAbbr;
                    });

                    for (var i in gfeUserIntervals) {
                        gfeUserIntervals[i].isOnCall = gfeUserIntervals[i]['type'] === 'ON_CALL';
                        gfeUserIntervals[i].location = _.findWhere(self.brandsList, {id: gfeUserIntervals[i].brand_id});
                    }

                    return gfeUserIntervals || [];
                }
            }
        };

        self.onIncentiveRuleChange = () => {
            const currency = $filter("locationCurrencySymbol")(self.brand);
            self.incetiveRuleInfo = incentiveOpenShiftPayment.getRuleDetails(self.data.incentiveDetails.incentiveRule, currency);
        }

        var getUserPickedUpSwappedShifts = function (userId, shiftId) {
            if (self.usersPickedUpSwappedShifts && shiftId && !isNaN(userId)) {
                var userPickedUpSwappedShifts = _.filter(self.usersPickedUpSwappedShifts, function (offerItem) {
                    if (offerItem['type'] === 'SWAP') {
                        return (
                            (
                                parseInt(userId) === offerItem['to_user_id'] &&
                                offerItem['original_assignee_shift'] &&
                                shiftId === offerItem['original_assignee_shift']['unpublished_assignee_shift_id']
                            ) ||
                            (
                                parseInt(userId) === offerItem['from_user_id'] &&
                                offerItem['destination_assignee_shift'] &&
                                shiftId === offerItem['destination_assignee_shift']['unpublished_assignee_shift_id']
                            )
                        );
                    } else if (offerItem['type'] !== 'DROP') {
                        return (
                            parseInt(userId) === offerItem['to_user_id'] &&
                            offerItem['destination_assignee_shift'] &&
                            shiftId === offerItem['destination_assignee_shift']['unpublished_assignee_shift_id']
                        );
                    }
                });

                if (userPickedUpSwappedShifts.length) {
                    var originalShiftDetails = {type: userPickedUpSwappedShifts[0]['type']};

                    if (userPickedUpSwappedShifts[0]['from_user_id'] == userId) {
                        originalShiftDetails['from_user'] = TSUsersService.users[parseInt(userPickedUpSwappedShifts[0]['to_user_id'])];
                        originalShiftDetails['from_shift'] = userPickedUpSwappedShifts[0]['original_assignee_shift'];
                    } else {
                        originalShiftDetails['from_user'] = TSUsersService.users[parseInt(userPickedUpSwappedShifts[0]['from_user_id'])];
                        originalShiftDetails['from_shift'] = userPickedUpSwappedShifts[0]['destination_assignee_shift'];
                    }

                    return originalShiftDetails;
                }
            }
        };

        self.onOptionSelect = function (target, interval) {
            return function (option) {
                var metaObj = {};
                if (option.next_day) {
                    metaObj.appendText = $filter('translate')('Next Day');
                    metaObj.prependIcon = 'next-day-icon';
                } else {
                    metaObj.appendText = '';
                    metaObj.prependIcon = '';
                }

                if (interval) {
                    interval[target + '_meta'] = metaObj;
                } else {
                    self[target + '_meta'] = metaObj;
                }
            }
        };

        let getAppliedWaiverOnFileTypes = function (waiverOnFileBreakTypes) {
            return waiverOnFileBreakTypes.reduce((acc, file) => {
                const consentedBreaks = file.breaks.filter(breakInfo => breakInfo.status === "CONSENTED");
                return acc.concat(consentedBreaks);
            }, []);
        }

        self.load = function (formData) {
            self.formData = formData;
            self.canManageSchedule = self.formData.canManageSchedule;
            self.isNYSateRulesEnabled = formData['GFEAppliedCity'] === 'NY';
            self.user = TSUsersService.users[formData.employeeId];
            self.isRequestedByAssignee = self.formData.shift && self.formData.shift.is_requested_by_assignee ;
            self.showShiftRepeatOptions = false;
            self.activeScheduleView = self.formData['activeScheduleView'];

            if (self.formData.shift && self.formData.shift.earliest_published_time && self.formData.shift.exposure_time) {
                self.isLastPublishDateShown = true;
                if (moment(self.formData.shift.earliest_published_time).isSame(moment(self.formData.shift.exposure_time))) {
                    self.isLastPublishDateShown = false;
                }
            }
            if (self.formData.revenueCenters) {
                self.availableRevenueCenters = Object.keys(self.formData.revenueCenters).length;
            }
            self.hasManageHourlyWagesAccess = formData['hasManageHourlyWagesAccess'];


            if (ScheduleDataServiceV2.isMarkedDay(moment(self.formData.day))) {
                var holidaysForSelectedDate = ScheduleDataServiceV2.getHolidaysNamesPerDay(moment(self.formData.day));
                self.holidaysList = holidaysForSelectedDate;
            }

            const incentiveSettings = ScheduleDataServiceV2.getIncentiveOpenShiftSettings();

            self.enabledIncentiveSettings = incentiveOpenShiftPayment.getShownShiftIncentivePayments(self.formData.shift, incentiveSettings);
            self.activeInceniveRulesMap = incentiveOpenShiftPayment.getActiveIncentiveRules(incentiveSettings?.[self.INCENTIVE_PAYMENT_TYPES.RULE_BASED]?.rules, self.formData.day)

            delete  self.errorMessage;

            TeamScheduleService
                .getActiveBrand()
                .then(function (brand) {
                    self.brand = brand;
                    self.isMinorRulesEnabled = self.brand.is_minor_rules_enabled;

                    var promises = {
                        'labels': ScheduleDataServiceV2.getBrandLabels(self.brand.id),
                        'settings': ScheduleDataServiceV2.getScheduleSettings(self.brand.id),
                        'policyParser': userPermissions.getBrandPolicy(brand.id),
                        'isFairSchedulingServiceEnabled': userServices.isServiceEnabled(userServices.SERVICES.FAIR_SCHEDULING, brand.id),
                        'isJobTitleSkillLevelServiceEnabled': userServices.isServiceEnabled(userServices.SERVICES.JOB_TITLE_SKILL_LEVEL, brand.id),
                        'isWendysLaborServiceEnabled': userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brand.id),
                        'goodFaithEstimateUsers': goodFaithEstimateService.getUsersGFE(brand.id, ScheduleDataServiceV2.startDate),
                        'offeredShifts': ScheduleDataServiceV2.getBrandShiftsOffers(brand.id, ScheduleDataServiceV2.startDate),
                        'brandsList': TeamScheduleService.getBrands(),
                        'employeeLatenessReasons': ScheduleDataServiceV2.getLatenessReasons(),
                        'isWorkRestrictionServiceEnabled' : userServices.isServiceEnabled(userServices.SERVICES.EMPLOYEE_WORK_RESTRICTION, brand.id)
                    };

                    var usersToLoad = []
                    if (self.formData.shift && self.formData.shift.earliest_published_by &&
                        !TSUsersService.users[self.formData.shift.earliest_published_by]) {
                        usersToLoad.push(self.formData.shift.earliest_published_by);
                    }
                    if (self.formData.shift && self.formData.shift.published_by &&
                        !TSUsersService.users[self.formData.shift.published_by] &&
                        usersToLoad.indexOf(self.formData.shift.published_by) === -1) {
                        usersToLoad.push(self.formData.shift.published_by);
                    }

                    if (usersToLoad.length) {
                        promises['loadUsers'] = TSUsersService.loadUsers(self.brand.id, usersToLoad);
                    }

                    $q.all(promises)
                        .then(function (res) {
                            self.isFairSchedulingServiceEnabled = res['isFairSchedulingServiceEnabled'];
                            self.isJobTitleSkillLevelServiceEnabled = res['isJobTitleSkillLevelServiceEnabled'];
                            self.isScheduledBreaksEnabled = res['settings'].shift_break_times_mode === 'MANUAL_ENTRY';
                            self.isRevenueCenterEnabled = res['settings']['is_revenue_center_enabled'];
                            self.isAssigneeShiftForecastedRecurrenceEnabled = res['settings']['assignee_shift_forecasted_recurrence_enabled'];
                            self.isAssigneeShiftLabelEnabled = res['settings']['is_assignee_shift_label_enabled'];
                            isShiftAssignmentAcrossDifferentPositionsEnabled = res['settings']['enable_shift_assignments_across_different_positions'];
                            var penaltyGeneralSettings = res['settings']['fair_work_week_settings'] &&
                                res['settings']['fair_work_week_settings']['penalty_general_settings'];
                            self.isEmployeeConsentFlowEnabled = (penaltyGeneralSettings && penaltyGeneralSettings.employee_consent_flow_enabled);
                            self.hasPendingEmployeeConsent = ((self.isEmployeeConsentFlowEnabled && self.formData.shift.employee_consent) ? self.formData.shift.employee_consent.status === 'PENDING_EMPLOYEE_APPROVAL' : false);
                            if (self.formData.shift.id && penaltyGeneralSettings && penaltyGeneralSettings.fww_mass_communication_settings_enabled) {
                                var shiftSource = ScheduleDataServiceV2.getShiftSources(self.formData.shift.id);
                                self.hasMassCommunication = ['LOCATION_PERIOD_CHANGE_WITH_MASS_COMMS', 'DROP_OFFER'].indexOf(shiftSource) > -1;
                            }
                            self.goodFaithEstimateUsers = res['goodFaithEstimateUsers'];
                            self.usersPickedUpSwappedShifts = res['offeredShifts'] && res['offeredShifts']['offers'];

                            _jobTitleFuncs.setIsWendysLaborServiceEnabled(res['isWendysLaborServiceEnabled']);
                            _jobTitleFuncs.setIsAssigneeShiftJobTitleTimesEnforced(res['settings']['is_assignee_shift_job_title_times_enforced']);
                            _jobTitleFuncs.setShiftSelectedDate(self.formData.day);

                            self.isAssigneeShiftJobTitleTimesEnforced = res['settings']['is_assignee_shift_job_title_times_enforced'];
                            self.brandsList = res['brandsList'];
                            self.employeeLatenessReasons = res['employeeLatenessReasons'];
                            self.isWorkRestrictionServiceEnabled = res['isWorkRestrictionServiceEnabled'];
                            self.labels = res.labels || [];
                            self.offeredToList = [];
                            self.offeredToUserIds = [];

                            var policyParser = res.policyParser;
                            self.hasManageDateOfBirthPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_DATE_OF_BIRTH);

                            self.shiftBasedScheduling = res.settings.schedule_shift_mode === "TEMPLATE";
                            self.breakEngines = res.settings.break_engines;
                            self.approvalWorkflowEnabled = res.settings.schedule_publish_mode === 'SUBMISSION';
                            var businessDay = TeamScheduleService.getBusinessDay(self.formData.day);
                            self.businessDayLimits = businessDayUtils.getBusinessDayLimits(businessDay, self.formData.day);
                            _jobTitleFuncs.setBusinessDayLimits(self.businessDayLimits);
                            self.availabilities = ScheduleDataServiceV2.availabitlies || {};

                            checkFairSchedulingWeekThreshold(res.settings, self.formData.day, formData.shift.day);
                            if (self.isJobTitleSkillLevelServiceEnabled) {
                                _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(formData.employeeId);
                            }

                            if (self.isWorkRestrictionServiceEnabled && self.user && self.user.hasWorkVisa()) {
                                var usersWorkVisaTypes = workVisasService.usersWorkVisaTypes;
                                self.visaType = getShiftWorkVisaType(usersWorkVisaTypes[self.user.id], formData.shift)
                            }

                            if (formData.shift) {
                                if (self.formData.shift.earliest_published_by) {
                                    self.data.earliestPublishedBy = TSUsersService.users[self.formData.shift.earliest_published_by];
                                }
                                if (self.formData.shift.published_by) {
                                    self.data.publishedBy = TSUsersService.users[self.formData.shift.published_by];
                                }
                                self.formData.day = formData.day || formData.shift.day || moment(formData.shift.start_time).format("MMM DD, YYYY");
                                _jobTitleFuncs.setShiftSelectedDate(self.formData.day);
                                const labelsMap = self.labels.reduce((previousValue, currentValue) => {
                                    previousValue[currentValue.id] = currentValue
                                    return previousValue;
                                }, {});
                                self.data.labels = formData.shift.labels?.length ? formData.shift.labels.map((labelId) => labelsMap[labelId]) : null;
                                self.data.revenue_center_id = formData.shift.revenue_center_id;
                                self.data.startTime = new Date(formData.shift.start_time);
                                self.data.endTime = new Date(formData.shift.end_time);
                                self.data.note = formData.shift.note || {text: ""};
                                self.data.incentiveDetails = incentiveOpenShiftPayment.parseShiftIncentiveData(formData.shift.incentive_payments, incentiveSettings?.[self.INCENTIVE_PAYMENT_TYPES.RULE_BASED]?.rulesMap);
                                self.originalIncentiveRule = self.data.incentiveDetails.incentiveRule;
                                self.onIncentiveRuleChange();
                                currentDay = formData.shift.currentDay;
                                var startOfDay = currentDay;
                                var endOfDay = currentDay + 24 * 60 * 60 * 1000;
                                if (startOfDay > formData.shift.start_time) {
                                    formData.shift.actualStart = startOfDay;
                                } else {
                                    formData.shift.actualStart = self.data.startTime.getTime();
                                }

                                if (formData.shift['forecasted_recurrence'] && self.isAssigneeShiftForecastedRecurrenceEnabled) {
                                    self.data.forecasted_recurrence = formData.shift.forecasted_recurrence;
                                }

                                if (endOfDay < formData.shift.end_time) {
                                    formData.shift.actualEnd = endOfDay;
                                } else {
                                    formData.shift.actualEnd = self.data.endTime.getTime();
                                }

                                var optedInEmployeesMap = ScheduleDataServiceV2.optedInEmployeesMap || {};

                                if (optedInEmployeesMap) {
                                    self.showOptedInVSL = optedInEmployeesMap[formData.shift['id'] + "_" + formData.shift['user_id']]
                                }

                                self.isExtendedFromPreviousDay = formData.shift['isExtendedFromPreviousDay'];
                            }
                            self.automaticeRulesMap = ScheduleDataServiceV2.getAutomaticIncentiveRulesMap()?.[self.formData.day] ?? {};

                            self.effectiveBreakEngine = breaksManagementService.getEffectiveBreakEngine(self.breakEngines, formData.day);

                            if (self.shiftBasedScheduling) {
                                self.template = ScheduleDataServiceV2.shiftsTemplates[formData.shift.code];
                                self.showShiftValue = false;

                                for (var i in brand.employee_payment_types) {
                                    var paymentTypeItem = brand.employee_payment_types[i];

                                    if (paymentTypeItem.type === "WEIGHTED_SHIFT" || (paymentTypeItem.type === "SALARIED" && paymentTypeItem.track_mode === "WEIGHTED_SHIFT")) {
                                        self.showShiftValue = true;
                                        break;
                                    }
                                }

                                if (formData.shift.code) {
                                    self.template = self.template || {code: formData.shift.code};
                                }
                            } else {
                                if (self.showExtendedShiftIcon()) {
                                    self['end_time_meta'] = {
                                        appendText: $filter('translate')('Next Day'),
                                        prependIcon: 'next-day-icon'
                                    }
                                } else {
                                    self['end_time_meta'] = {
                                        appendText: '',
                                        prependIcon: ''
                                    }
                                }
                            }

                            var promises = {
                                'roleEmployees': getRoleEmployees(),
                            };

                            if (self.isEmployeeConsentFlowEnabled && self.formData.shift && self.formData.shift.id) {
                                promises['publishedShifts'] = fairSchedulingService.loadSchedulePublishTree(self.brand.id, ScheduleDataServiceV2.startDate)
                            }

                            if (self.isScheduledBreaksEnabled && formData.employeeId) {
                                promises['waiverOnFileStatus'] = PerformanceAggregatorAPI.getWaiverOnFileStatus(brand.id, formData.employeeId, moment(ScheduleDataServiceV2.startDate).format('YYYY-MM-DD'));
                            }

                            $q.all(promises).then(function (res) {
                                if (res['publishedShifts']) {
                                    var schedulePublishFlatData = fairSchedulingService.parseFlatScheduleData(res['publishedShifts'] || {});
                                    for (var i in schedulePublishFlatData) {
                                        if (schedulePublishFlatData[i].reference_id && schedulePublishFlatData[i].reference_id === self.formData.shift.id) {
                                            publishedShift = schedulePublishFlatData[i];
                                            break;
                                        }
                                    }
                                }

                                if (res['waiverOnFileStatus']) {
                                    self.waiverOnFileBreaks = getAppliedWaiverOnFileTypes(res['waiverOnFileStatus']);
                                }

                                // Select default employee
                                if (!formData.employeeId) {
                                    self.data.employee = self.employees[0].items[0];
                                    if (self.isAssigneeShiftForecastedRecurrenceEnabled) {
                                        self.showShiftRepeatOptions = true;
                                        if (!self.data.forecasted_recurrence) {
                                            self.data.forecasted_recurrence = 'ONCE';
                                        }
                                    }
                                } else {
                                    for (let employee of self.employees[1].items) {
                                        if (employee.id == formData.employeeId) {
                                            self.data.employee = employee;
                                            break;
                                        }
                                    }
                                    if (!self.data.employee) {
                                        console.warn("this user is invalid");
                                    }
                                }

                                const userCosts = ScheduleCostsServiceV2.flatData?.costs?.[self.data.employee?.id];
                                self.isHourlyEmployee = !self.data.employee?.id || userCosts?.pay_type?.[self.formData.day]?.type === 'HOURLY';

                                // Select default role
                                if (formData.position_code) {
                                    for (var index in self.data.employee.positions) {
                                        var position = self.data.employee.positions[index];
                                        if (position.code == formData.position_code) {
                                            self.data.role = position;
                                            if (formData.role_id) {
                                                self.data.role.id = formData.role_id;
                                            }

                                            self.employees = getEmployeesPositionGroups(self.positions, position);
                                            break;
                                        }
                                    }
                                }

                                self.activeInceniveRules = incentiveOpenShiftPayment.getActiveRulesForPosition(self.activeInceniveRulesMap, self.data.role?.category?.code, self.data.role?.code);

                                if (formData.shift.offered_to && formData.shift.offered_to.length) {
                                    for (var i in formData.shift.offered_to) {
                                        var offeredToUserId = formData.shift.offered_to[i]['user_id'];
                                        const offeredToUser = self.positions.all.find(position => position.id === offeredToUserId);

                                        self.offeredToList.push(offeredToUser);
                                        self.offeredToUserIds.push(offeredToUserId);
                                    }
                                }

                                if (self.isMinorRulesEnabled) {
                                    showMinorDetailsIfMinor(self.data.employee && self.data.employee.id);
                                }

                                if (self.shiftBasedScheduling && self.data.role) {
                                    self.shiftsTemplates = getPositionTemplates(self.data.role.code);
                                }

                                prepareShiftInitialData(angular.copy(self.template), formData.shift, true);
                                prepareEmployeeAvailabilitiesList(formData.employeeId);
                                self.checkMarkedDay(formData.employeeId);
                                self.gfeUserIntervals = prepareUserGFEIntervalsForDay(self.data.employee && self.data.employee.id, self.formData.day);
                                self.originalShiftDetails = getUserPickedUpSwappedShifts(self.data.employee && self.data.employee.id, self.formData.shift.id);

                                self.isNewlyHiredEmployee = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(self.formData.day, formData.employeeId, false, self.data.role);
                                self.isNewlyHiredForWeek = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(ScheduleDataServiceV2.startDate, formData.employeeId, true);
                                isOvernightShiftSettingsEnabled = ScheduleDataServiceV2.checkOvernightShiftsSettings(ScheduleDataServiceV2.startDate);
                                self.shiftStatus = formData.shift.status || 'UNPUBLISHED';
                                checkIfAvailabilityConflicts();
                                checkDifferentialPaymentWarning();
                                checkIncentiveWarning();

                                self.shiftStartTimeOptions = hTimePickerUtils.getIntervalOptions( {
                                    from: self.businessDayLimits.openTime,
                                    to: self.businessDayLimits.closeTimeWithoutExtension,
                                    withInfo: false,
                                    minutesPeriod: 15,
                                    includeFrom: true,
                                    includeTo: false,
                                    closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                                });
                                _jobTitleFuncs.updateJobTitlesEndTimeOptions();
                                prepareShiftEndTimeOptions();
                                prepareTimeWithinShiftOptions();
                                self.loading = false;
                            });
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                });
        };

        self.prepareJobTitleEndTimeOptions = (jobTitle, shiftEndTime) => {
            let endTimeOptions = [];
            if (jobTitle.start_time && shiftEndTime) {
                const from = moment(jobTitle.start_time);
                let to = moment(shiftEndTime);
                if (from.clone().add(1, 'day').isBefore(to)) {
                    to = from.clone().add(1, 'day');
                }
                endTimeOptions = hTimePickerUtils.getIntervalOptions({
                    from: from,
                    to: to,
                    withInfo: true,
                    minutesPeriod: 15,
                    includeFrom: false,
                    includeTo: true,
                    closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                });
            }
            return endTimeOptions;
        };

        var updateShiftInterval = function () {
            var interval;
            if (self.shiftBasedScheduling) {
                var startTime = self.shiftIntervals
                    && self.shiftIntervals[0]
                    && self.shiftIntervals[0].start_time;
                var endTime = self.shiftIntervals
                    && self.shiftIntervals[self.shiftIntervals.length - 1]
                    && self.shiftIntervals[self.shiftIntervals.length - 1].end_time;
                interval = {start_time: startTime, end_time: endTime};
            }
            else {
                interval = {
                    start_time: self.data.startTime,
                    end_time: self.data.endTime
                }
            }
            return interval;
        }

        self.hasDynamicBreaks = () => {
            return ((self.effectiveBreakEngine === 'DYNAMIC') && self.isScheduledBreaksEnabled && (!!self.shiftPaidBreaks?.length || !!self.shiftUnpaidBreaks.length));
        }

        self.hasStaticBreaks = () => {
            return ((self.effectiveBreakEngine === 'STATIC') && self.shiftBasedScheduling);
        }

        self.autoAssignBreaks = () => {
            self.preparingBreaks = true;
            const shift = {
                id: 1,
                start_time: self.shiftBasedScheduling ? self.shiftIntervals[0].start_time : self.data.startTime,
                end_time: self.shiftBasedScheduling ? self.shiftIntervals[self.shiftIntervals.length - 1].end_time : self.data.endTime,
                day: self.formData.day,
                position: self.data.role,
                user_id: self.data.employee.id,
            }

            const breaksAssigningCallback = (progress, totalCount, complete, succeededShifts, failedShifts) => {
                succeededShifts = succeededShifts ?? [];

                if (complete) {
                    self.shiftStatus = 'UNPUBLISHED';
                    let shiftBreaks = succeededShifts?.[0]?.breaks ?? [];

                    for (let i = 0; i < shiftBreaks.length; i++) {
                        let firstBreak = shiftBreaks[i];

                        for (let j = i + 1; j < shiftBreaks.length; j++) {
                            let secondBreak = shiftBreaks[j];
                            if (breaksAutoAssignService.checkIfTwoBreaksOverlap(firstBreak, secondBreak)) {
                                secondBreak.start_time = null;
                                secondBreak.end_time = null;
                            }
                        }
                    }

                    shiftBreaks = shiftBreaks.map((breakItem) => {
                        breakItem.duration = parseFloat((breakItem.duration / 60).toFixed(2));

                        return breakItem;
                    });

                    const paidBreaks = shiftBreaks.filter((breakItem) => (breakItem.payment_type === 'PAID'));
                    const unpaidBreaks = shiftBreaks.filter((breakItem) => (breakItem.payment_type === 'UNPAID'));

                    self.shiftPaidBreaks = paidBreaks.map((breakItem) => {

                        if (breakItem.start_time) {
                            const breakObject = ShiftTemplateUtils.getPeriod(breakItem.start_time, breakItem.end_time, self.formData.day);
                            breakItem.start_time = breakObject.start;
                            breakItem.end_time = breakObject.end;
                        }

                        return breakItem;
                    });
                    self.shiftUnpaidBreaks = unpaidBreaks.map((breakItem) => {
                        if (breakItem.start_time) {
                            const breakObject = ShiftTemplateUtils.getPeriod(breakItem.start_time, breakItem.end_time, self.formData.day);
                            breakItem.start_time = breakObject.start;
                            breakItem.end_time = breakObject.end;
                        }

                        return breakItem;
                    });

                    self.templateDataChanged();
                }

                self.preparingBreaks = !complete;
            }

            const breaksRulesMap = ScheduleCostsServiceV2.breaksMap;
            const closeTime = ScheduleDataServiceV2.dayCloseHour + ScheduleDataServiceV2.dayCloseHourExtension;
            breaksAutoAssignService.assignBreaks([shift], [shift.id], breaksAssigningCallback, breaksRulesMap, ScheduleDataServiceV2.startDate, ScheduleDataServiceV2.dayOpenHour, closeTime, self.isAssigneeShiftJobTitleTimesEnforced, false, false);
        }

        self.onError = function (error) {
            self.errorMessage = error;
            scope.$digest();
        };

        // Added this to the scope because h-select component doesn't take the onChange function from the form
        scope.roleChanged = function () {
            setTimeout(function () {
                self.employees = getEmployeesPositionGroups(self.positions, self.data.role);

                self.shiftStatus = 'UNPUBLISHED';
                self.activeInceniveRules = incentiveOpenShiftPayment.getActiveRulesForPosition(self.activeInceniveRulesMap, self.data.role?.category?.code, self.data.role?.code);

                if (
                    !self.data.employee?.id &&
                    self.enabledIncentiveSettings[self.INCENTIVE_PAYMENT_TYPES.RULE_BASED].shown &&
                    !incentiveOpenShiftPayment.checkIfRuleStillApplyToPosition(self.data.incentiveDetails?.incentiveRule, self.data.role?.category?.code, self.data.role?.code)
                ) {
                    self.data.incentiveDetails.incentiveRule = incentiveOpenShiftPayment.getAutomaticAppliedRuleOnPosition(self.automaticeRulesMap, self.data.role?.category?.code, self.data.role?.code);
                    self.onIncentiveRuleChange();
                }

                if (self.shiftBasedScheduling) {
                    self.clearTemplate();
                    self.shiftsTemplates = getPositionTemplates(self.data.role.code);
                }

                prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);
                checkDifferentialPaymentWarning();
                checkIncentiveWarning();
                self.isNewlyHiredEmployee = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(self.formData.day, self.data.employee.id, false, self.data.role);
                self.isNewlyHiredForWeek = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(ScheduleDataServiceV2.startDate, self.data.employee.id, true);
                scope.$digest();
            }, 1);
        };

        const getEmployeesPositionGroups = (allEmployees, position) => {
            const employeesGroups = [
                {
                    label: '',
                    items: [unAssignedEmployee]
                }
            ];

            if (position?.code) {
                if (isShiftAssignmentAcrossDifferentPositionsEnabled) {
                    const positionEmployees = allEmployees[position.code];
                    employeesGroups.push(
                        {
                            label: $filter("translate")(`Employees assigned to ${position.name}`),
                            items: positionEmployees
                        },
                        {
                            label: $filter("translate")("Other employees"),
                            items: allEmployees.all.filter(employee => !positionEmployees.some(positionEmployee => positionEmployee.id === employee.id))
                        }
                    );
                } else {
                    employeesGroups.push(
                        {
                            label: '',
                            items: allEmployees[position.code]
                        }
                    );
                }
            } else {
                employeesGroups.push(
                    {
                        label: '',
                        items: allEmployees.all
                    }
                );
            }

            return employeesGroups;
        }

        var prepareTemplateData = function (selectedTemplate, selectedShift) {
            var template =  angular.copy(selectedTemplate);
            self.shiftIntervals = [];
            self.shiftPaidBreaks = [];
            self.shiftUnpaidBreaks = [];

            if (template) {
                self.data.weight = template.weight;

                var intervals = template && template.intervals || [];

                for (var i in intervals) {
                    var interval = intervals[i];

                    if (interval.start_time !== null && interval.end_time !== null) {
                        var period = ShiftTemplateUtils.getPeriod(interval.start_time, interval.end_time, self.formData.day);

                        self.shiftIntervals.push({
                            "start_time": period.start,
                            "end_time": period.end
                        });
                    }
                }
            } else {
                self.data.weight = selectedShift.weight != undefined ? selectedShift.weight : 1;

                var timeBreaksObj = {
                    "start_time": selectedShift.start_time,
                    "end_time": selectedShift.end_time,
                    "breaks": selectedShift.breaks
                };

                var intervalsObj = ShiftTemplateUtils.getIntervalsFromTimeAndBreaks(timeBreaksObj);

                for (var i in intervalsObj) {
                    var interval = intervalsObj[i];

                    if (interval.start_time !== null && interval.end_time !== null) {
                        var day = self.formData.shift? self.formData.shift.start_time: self.formData.day;
                        var period = ShiftTemplateUtils.getPeriod(interval.start_time, interval.end_time, day);

                        self.shiftIntervals.push({
                            "start_time": period.start,
                            "end_time": period.end
                        });
                    }
                }

            }

            if (!self.shiftIntervals.length) {
                self.addInterval();
            }

            updateShiftIntervalsTimeOptions();

            prepareShiftTimeFromTemplateIntervals();
            prepareTimeWithinShiftOptions();
            // reset validation
            self.exceedMaxBreaksTime = false;
        };

        var updateShiftIntervalsTimeOptions = function () {
            if (self.shiftIntervals && self.shiftIntervals.length) {
                for (var i in self.shiftIntervals) {
                    prepareIntervalTimeOptions(i);
                    if (i == self.shiftIntervals.length - 1) {
                        if (self.showExtendedShiftIcon()) {
                            self.shiftIntervals[i]['end_time_meta'] = {
                                appendText: $filter('translate')('Next Day'),
                                prependIcon: 'next-day-icon'
                            }
                        } else {
                            self.shiftIntervals[i]['end_time_meta'] = {
                                appendText: '',
                                prependIcon: ''
                            }
                        }
                    }
                }
            }
        };

        var prepareIntervalTimeOptions = function (intervalIndex, timeChanged) {
            var interval = self.shiftIntervals[parseInt(intervalIndex)];
            var previousInterval = self.shiftIntervals[parseInt(intervalIndex) - 1];
            var nextInterval = self.shiftIntervals[parseInt(intervalIndex) + 1];
            var from, to;
            to = self.businessDayLimits.closeTime;

            if (!timeChanged) {
                if (previousInterval && previousInterval.end_time) {
                    from = moment(previousInterval.end_time);
                } else {
                    from = self.businessDayLimits.openTime;
                }
                interval.startTimeOptions = hTimePickerUtils.getIntervalOptions( {
                    from: from,
                    to: self.businessDayLimits.closeTimeWithoutExtension,
                    withInfo: false,
                    minutesPeriod: 15,
                    includeFrom: !previousInterval,
                    includeTo: false,
                    closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                });
            }

            if (!timeChanged || timeChanged === 'start_time') {
                if (interval.start_time) {
                    from = moment(interval.start_time);
                    var endTimeTo = to.clone();
                    if (from.clone().add(1, 'day').isBefore(endTimeTo)) {
                        endTimeTo = from.clone().add(1, 'day');
                    }
                    interval.endTimeOptions = hTimePickerUtils.getIntervalOptions({
                        from: from,
                        to: endTimeTo,
                        withInfo: true,
                        minutesPeriod: 15,
                        includeFrom: false,
                        includeTo: true,
                        closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                    });
                } else {
                    interval.endTimeOptions = [];
                }
            }

            if (timeChanged === 'end_time') {
                if (nextInterval) {
                    if (interval.end_time) {
                        from = moment(interval.end_time);
                    }
                    else if (interval.start_time) {
                        from = moment(interval.start_time);
                    }
                    else {
                        from = self.businessDayLimits.openTime;
                    }

                    var withinTimeTo = to.clone();
                    if (from.clone().add(1, 'day').isBefore(withinTimeTo)) {
                        withinTimeTo = from.clone().add(1, 'day');
                    }
                    nextInterval.startTimeOptions = hTimePickerUtils.getIntervalOptions( {
                        from: from,
                        to: withinTimeTo,
                        withInfo: false,
                        minutesPeriod: 15,
                        includeFrom: true,
                        includeTo: false,
                        closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                    });
                }
            }

        }
        var prepareShiftInitialData = function (template, selectedShift, isFirstLoad) {
            prepareTemplateData(template, selectedShift);
            prepareBreaks(template, isFirstLoad);
            var jobTitles = (isFirstLoad? selectedShift.job_titles : template.job_titles) || [];

            if (self.isJobTitleSkillLevelServiceEnabled) {
                var formattedTemplateJobTitles;
                if (isFirstLoad) {
                    var interval = updateShiftInterval();
                    _jobTitleFuncs.updateIntervalStartAndEndTime(interval);
                    formattedTemplateJobTitles = selectedShift.job_titles;
                }
                else {
                    var day = self.formData.shift? self.formData.shift.start_time: self.formData.day;
                    formattedTemplateJobTitles = ShiftTemplateUtils.formatTemplateJobTitlesTimes(angular.copy(jobTitles), day);
                }
                var templateJobTitles = _jobTitleFuncs.mapJobTitles(formattedTemplateJobTitles);
                self.initJobTitles(templateJobTitles);
                _jobTitleFuncs.setCurrency(getBrandCurrency());
            }
        }

        const getBrandCurrency = () => $filter("locationCurrencySymbol")(self.brand);

        scope.shiftTemplateChanged = function (newValue) {
            if (newValue && newValue[0]) {
                self.data.job_titles = [];
                prepareShiftInitialData(newValue[0]);
                if (self.data.job_titles.length) {
                    _jobTitleFuncs.updateJobTitlesEndTimeOptions();
                }
            }

            scope.$digest();
        };

        self.shiftValueChanged = function () {
            self.templateDataChanged();
        };

        self.addInterval = function () {
            self.shiftIntervals.push({});
            prepareIntervalTimeOptions(self.shiftIntervals.length - 1);
        };

        self.removeInterval = function (index) {
            if (self.validator.validation["start_time" + index]) {
                delete self.validator.validation["start_time" + index];
            }

            if (self.validator.validation["end_time" + index]) {
                delete self.validator.validation["end_time" + index];
            }

            self.shiftIntervals.splice(index, 1);

            if (!self.shiftIntervals.length) {
                self.addInterval();
            }

            checkIfAvailabilityConflicts();
            checkDifferentialPaymentWarning();
            checkIncentiveWarning();

            self.breakTimeChanged();
            prepareIntervalTimeOptions(index);
            self.templateDataChanged();
        };

        self.addPaidBreak = function () {
            self.shiftPaidBreaks.push({
                "duration": 0,
                "type": "PAID"
            });
        };

        self.removePaidBreak = function (index) {
            if (self.validator.validation["paid_duration" + index]) {
                delete self.validator.validation["paid_duration" + index];
            }

            self.shiftPaidBreaks.splice(index, 1);

            if (!self.shiftPaidBreaks.length) {
                self.addPaidBreak();
            }

            self.breakTimeChanged();
            self.templateDataChanged();
        };

        self.addUnpaidBreak = function () {
            self.shiftUnpaidBreaks.push({
                "duration": 0,
                "type": "UNPAID"
            });
        };

        self.removeUnpaidBreak = function (index) {
            if (self.validator.validation["unpaid_duration" + index]) {
                delete self.validator.validation["unpaid_duration" + index];
            }

            self.shiftUnpaidBreaks.splice(index, 1);

            if (!self.shiftUnpaidBreaks.length) {
                self.addUnpaidBreak();
            }

            self.breakTimeChanged();
            self.templateDataChanged();
        };

        self.updateBreakEndTime = function (breakItem, validateTarget, validateIndex) {
            self.shiftStatus = 'UNPUBLISHED';
            if (breakItem.start_time) {
                breakItem.end_time = moment(breakItem.start_time).clone().add(breakItem.duration, "minutes");
            } else {
                breakItem.end_time = null;
            }
            self.templateDataChanged();

            if (validateTarget && validateIndex) {
                setTimeout(function () {
                    $("." + formName)
                        .find('[validate-index="' + validateIndex + '"][validate-target="' + validateTarget + '"] ' + validateTarget)
                        .trigger('change');
                }, 200);
            }
        };

        var getTotalBreaksTime = function () {
            var total = 0;

            for (var i in self.shiftPaidBreaks) {
                var paidBreakTime = self.shiftPaidBreaks[i];

                total += paidBreakTime.duration || 0;
            }

            for (var i in self.shiftUnpaidBreaks) {
                var unpaidBreakTime = self.shiftUnpaidBreaks[i];

                total += unpaidBreakTime.duration || 0;
            }

            return total;
        };

        self.breakTimeChanged = function (breakItem) {
            self.shiftStatus = 'UNPUBLISHED';
            if (self.effectiveBreakEngine === 'STATIC' && self.shiftBasedScheduling) {
                const totalBreaksTime = getTotalBreaksTime();
                const totalIntervalsTime = ShiftTemplateUtils.getIntervalsTotalTime(self.shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
                self.exceedMaxBreaksTime = totalIntervalsTime && ((totalIntervalsTime - totalBreaksTime) <= 0);
            }

            if (self.isScheduledBreaksEnabled && breakItem) {
                self.updateBreakEndTime(breakItem);
            }
            self.templateDataChanged();
        };

        //if shift has breaks, get breaks from shift
        //if break_engine STATIC and template selected, get breaks from template
        //if break_engine DYNAMIC and isScheduledBreaksEnabled, prepare deserved breaks list
        var prepareBreaks = function (template, firstLoad) {
            var breaksList = (firstLoad && self.formData.shift && self.formData.shift.breaks) || [];
            self.shiftPaidBreaks = [];
            self.shiftUnpaidBreaks = [];

            if (breaksList.length) {
                for (var i in breaksList) {
                    if (breaksList[i].start_time && breaksList[i].type !== 'SPLIT_SHIFT') {
                        self.isScheduledBreaksEnabled = true;
                        break;
                    }
                }
            }

            if (!breaksList.length) {
                if (template && self.effectiveBreakEngine === "STATIC") {
                    breaksList = template.breaks || [];
                }
            }

            for (var i in breaksList) {
                var shiftBreak = angular.copy(breaksList[i]);

                shiftBreak.duration = parseFloat((shiftBreak.duration / 60).toFixed(2));

                if (shiftBreak.start_time) {
                    var breakObject = ShiftTemplateUtils.getPeriod(shiftBreak.start_time, shiftBreak.end_time, self.formData.day);
                    shiftBreak["start_time"] = breakObject.start;
                    shiftBreak["end_time"] = breakObject.end;
                }

                if (shiftBreak.type === "PAID") {
                    self.shiftPaidBreaks.push(shiftBreak);
                } else if (shiftBreak.type === "UNPAID") {
                    self.shiftUnpaidBreaks.push(shiftBreak);
                }
            }

            // if breaks return from BE, frequency will not be return with breaks info so we need to add it with other breaks info
            prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role, (firstLoad && breaksList.length));

            if (self.effectiveBreakEngine === 'STATIC') {
                if (!self.shiftPaidBreaks.length) {
                    self.addPaidBreak();
                }

                if (!self.shiftUnpaidBreaks.length) {
                    self.addUnpaidBreak();
                }
            }
        };

        // if checkChangeSettings = true; only when first load modal
        // check if scheduled breaks changed due to breaks settings changes
        var prepareShiftDeservedBreaks = function (employeeId, position, checkChangeSettings) {
            if (self.effectiveBreakEngine === 'DYNAMIC' && self.isScheduledBreaksEnabled) {
                const breaksRules = ScheduleCostsServiceV2.getBreaksRulesForDay(self.formData.day);
                const intervals = self.shiftBasedScheduling ? self.shiftIntervals : [{start_time: self.data.startTime, end_time: self.data.endTime}];
                const breaksObject = breaksManagementService.calculateShiftDeservedBreaks(breaksRules, self.formData.day, ScheduleDataServiceV2.dayOpenHour, employeeId, position, intervals);
                const oldPaidBreaks = self.shiftPaidBreaks || [];
                const oldUnpaidBreaks = self.shiftUnpaidBreaks || [];

                if (checkChangeSettings) {
                    self.isRecalculateBreaksNeeded = breaksManagementService.checkIfBreaksNeedsRecalculation(oldPaidBreaks.concat(oldUnpaidBreaks), (breaksObject.paidBreaks ?? []).concat(breaksObject.unpaidBreaks ?? []))
                }

                if (self.isRecalculateBreaksNeeded) {
                    return;
                }

                for (var i in breaksObject.paidBreaks) {
                    if (oldPaidBreaks[i] && oldPaidBreaks[i].start_time) {
                        breaksObject.paidBreaks[i].start_time = oldPaidBreaks[i].start_time;
                        self.breakTimeChanged(breaksObject.paidBreaks[i]);
                    }
                }

                for (var i in breaksObject.unpaidBreaks) {
                    if (oldUnpaidBreaks[i] && oldUnpaidBreaks[i].start_time) {
                        breaksObject.unpaidBreaks[i].start_time = oldUnpaidBreaks[i].start_time;
                        self.breakTimeChanged(breaksObject.unpaidBreaks[i]);
                    }
                }

                self.shiftPaidBreaks = breaksObject.paidBreaks;
                self.shiftUnpaidBreaks = breaksObject.unpaidBreaks;
                self.breaksPreferredTimesList = breaksObject.breaksPreferredTimes;
            }
        };

        var checkEndTimeExceedBusinessDayWarning = function () {
            var showExceedBusinessDayWarning = false;

            if (self.shiftBasedScheduling) {
                showExceedBusinessDayWarning = isValidIntervals(self.shiftIntervals) && businessDayUtils.isInBusinessDayExtension(self.shiftIntervals, self.formData.day);
            } else {
                if (self.data.startTime && self.data.endTime) {
                    showExceedBusinessDayWarning = businessDayUtils.isInBusinessDayExtension({
                        start_time: self.data.startTime,
                        end_time: self.data.endTime
                    }, self.formData.day);
                }
            }

            return showExceedBusinessDayWarning;
        };

        var getAvailableIntervals = function(shift, unavailableRequests) {
            var availableIntervals = [{start: shift.start_time, end: shift.end_time}];

            for (var j = 0; j < unavailableRequests.length; j++) {
                var request = unavailableRequests[j];
                var requestStart = request.start_time;
                var requestEnd = request.end_time;

                var newAvailableIntervals = [];

                for (var k = 0; k < availableIntervals.length; k++) {
                    var interval = availableIntervals[k];
                    var intervalStart = interval.start;
                    var intervalEnd = interval.end;

                    if (requestEnd <= intervalStart || requestStart >= intervalEnd) {
                        newAvailableIntervals.push(interval);
                    } else if (requestStart > intervalStart && requestEnd < intervalEnd) {
                        newAvailableIntervals.push(
                            {start: intervalStart, end: request.start_time},
                            {start: request.end_time, end: intervalEnd}
                        );
                    } else if (requestStart <= intervalStart && requestEnd < intervalEnd) {
                        newAvailableIntervals.push({start: request.end_time, end: intervalEnd});
                    } else if (requestStart > intervalStart && requestEnd >= intervalEnd) {
                        newAvailableIntervals.push({start: intervalStart, end: request.start_time});
                    }
                }

                availableIntervals = newAvailableIntervals;
            }
            return availableIntervals;
        };

        var handleMergedAvailableIntervalMsg = function (availableInterval, shift) {
            if (availableInterval.start === shift.start_time) {
                return {
                    text: 'until ' + moment(availableInterval.end).format('hh:mm a'),
                    type: 'AVAILABLE',
                    isOnly: true
                }
            } else if (availableInterval.end === shift.end_time) {
                return {
                    text: 'after ' + moment(availableInterval.start).format('hh:mm a'),
                    type: 'AVAILABLE'
                }
            } else {
                return {
                    text: 'before ' + moment(availableInterval.start).format('hh:mm a') + ' and after ' + moment(availableInterval.end).format('hh:mm a'),
                    type: 'NOT_AVAILABLE'
                }
            }
            return null;
        };

        var handleSplittedAvailableIntervalMsg = function (availableIntervals, shift) {
            var availableIntervalPart1 = availableIntervals[0];
            var availableIntervalPart2 = availableIntervals[1];

            if (availableIntervalPart1.start === shift.start_time && availableIntervalPart2.end === shift.end_time) {
                return 'between (' + moment(availableIntervalPart1.end).format('hh:mm a') + ' - ' + moment(availableIntervalPart2.start).format('hh:mm a') + ')';
            } else {
                if (availableIntervalPart1.start === shift.start_time) {
                    return 'between (' + moment(availableIntervalPart1.end).format('hh:mm a') +
                        ' - ' + moment(availableIntervalPart2.start).format('hh:mm a') + ')' +
                        ' and ' + 'after ' + moment(availableIntervalPart2.end).format('hh:mm a');
                } else if (availableIntervalPart2.end === shift.end_time) {
                    return 'before ' + moment(availableIntervalPart1.start).format('hh:mm a') +
                        ' and ' + 'between (' + moment(availableIntervalPart1.end).format('hh:mm a') +
                        ' - ' + moment(availableIntervalPart2.start).format('hh:mm a') + ')';
                }
            }
            return null;
        };

        var formattedShiftIntervals =  function (shiftIntervals) {
            var formattedShiftIntervals = [];
            for (var i in shiftIntervals) {
                var interval = angular.copy(shiftIntervals[i]);
                var start = new Date(interval.start_time).getTime();
                var end = new Date(interval.end_time).getTime();
                formattedShiftIntervals.push({
                    start_time: start,
                    end_time: end
                })
            }
            return formattedShiftIntervals;
        };

        var isIntervalsOverlapped = function(interval1, interval2) {
            return !(interval1.end_time < interval2.start_time || interval1.start_time > interval2.end_time);
        }

        var handleUnavailableMsg = function (unavailableRequests, shiftsUnavailableMap) {
            var message = 'not available';
            var hasAllDayRequest = false;
            var overlappedRequests = [];

            for (var s in shiftsUnavailableMap) {
                var shiftInterval = shiftsUnavailableMap[s];
                if (hasAllDayRequest) {
                    break;
                }
                if (shiftInterval.is_unavailable) {
                    for (var j = 0; j < unavailableRequests.length; j++) {
                        var request = unavailableRequests[j];
                        if (request.is_all_day) {
                            hasAllDayRequest = true;
                            break;
                        }
                        else {
                            var isRequestOverLapped = isIntervalsOverlapped(request, shiftInterval);
                            if (isRequestOverLapped) {
                                var isRequestAlreadyInOverlapArray = overlappedRequests.find(function (overlapRequest) {
                                    return (overlapRequest.start_time === request.start_time && overlapRequest.end_time === request.end_time)
                                })

                                if (!isRequestAlreadyInOverlapArray) {
                                    var startTime = moment(request.start_time).format('hh:mm a');
                                    var endTime = moment(request.end_time).format('hh:mm a');
                                    overlappedRequests.push(' between ' + '('+ startTime + ' - ' + endTime + ')');
                                }
                            }
                        }
                    }
                }
            }
            if (!hasAllDayRequest) {
                message += overlappedRequests.join(' and ');
            }
            return message;
        }

        var hasConflictWithAvailabilities = function (intervals) {
            var shiftIntervals = formattedShiftIntervals(intervals);

            var unavailableRequestsForCurrentDay = self.currentDayUserRequests.otherRequests.concat(self.currentDayUserRequests.availabilities.AVAILABILITY || []);
            var unavailableRequestsForNextDay = self.nextDayUserRequests.otherRequests.concat(self.nextDayUserRequests.availabilities.AVAILABILITY || []);
            var unavailableRequests = unavailableRequestsForCurrentDay.concat(unavailableRequestsForNextDay || []);
            unavailableRequests = unavailableRequests.filter((request) => {
                return ScheduleWarningServiceV2.checkIfWarningEnabled(request.type);
            });
            var message = '';
            var intervalMsgs = [];
            var hasOneInterval = shiftIntervals.length == 1;
            var shiftsUnavailableMap = [];

            if (shiftIntervals.length === 0 || unavailableRequests.length === 0) {
                return;
            }
            for (var i = 0; i < shiftIntervals.length; i++) {
                var shiftInterval = shiftIntervals[i];
                var availableIntervals = getAvailableIntervals(shiftInterval, unavailableRequests);
                shiftsUnavailableMap.push({start_time: shiftInterval.start_time, end_time: shiftInterval.end_time, is_unavailable: availableIntervals.length === 0});

                if (availableIntervals.length) {
                    var availableIntervalPart1 = availableIntervals[0] || {};
                    var availableIntervalPart2 = availableIntervals[1] || {};
                    if (availableIntervalPart1['start'] === shiftInterval.start_time &&
                        availableIntervalPart1['end'] === shiftInterval.end_time) {
                        continue;
                    } else {
                        if (!_.isEmpty(availableIntervalPart1) && !_.isEmpty(availableIntervalPart2)) {
                            intervalMsgs.push(' not available '+ handleSplittedAvailableIntervalMsg(availableIntervals, shiftInterval));
                        }
                        else {
                            var mergedAvailableIntervalMsg = handleMergedAvailableIntervalMsg(availableIntervalPart1, shiftInterval);
                            if (mergedAvailableIntervalMsg) {
                                var availabilityType = mergedAvailableIntervalMsg.type === 'AVAILABLE' ? ' available ' : ' not available ';
                                intervalMsgs.push((hasOneInterval && mergedAvailableIntervalMsg.isOnly && mergedAvailableIntervalMsg.type === 'AVAILABLE' ?' only ' : '') + availabilityType + ' ' + mergedAvailableIntervalMsg.text);
                            }

                        }
                    }
                }
            }

            if (intervalMsgs.length) {
                message = 'This employee is' + intervalMsgs.join(' and ');

            } else {
                var hasAtLeastOneShiftUnavailable = shiftsUnavailableMap.find(function(value) {
                    return value.is_unavailable === true;
                });

                if (hasAtLeastOneShiftUnavailable) {
                    message = 'This employee is ' + handleUnavailableMsg(unavailableRequests, shiftsUnavailableMap);
                }
            }

            return message.trim();
        };

        var prepareEmployeeAvailabilitiesList = function (userId) {
            var userAvailabilities = angular.copy(self.availabilities[userId]) || [];
            self.currentDayUserRequests = {availabilities: {}, otherRequests: []};
            self.nextDayUserRequests = {availabilities: {}, otherRequests: []};
            var nextDay = moment(self.formData.day).add(1, 'd').format('MMM DD, YYYY');

            for (var i in userAvailabilities) {
                var availability = userAvailabilities[i];
                var availabilityDay = ScheduleDataServiceV2.getShiftDay(availability);
                var isRequestInNextDay;

                if (availabilityDay !== self.formData.day && availabilityDay !== nextDay) {
                    continue;
                }

                switch (availability['type']) {
                    case 'HOLIDAY':
                        availability['title'] = 'Holiday';
                        break;
                    case 'TIME_OFF':
                        availability['title'] = 'Time off';
                        break;
                    case 'SICKNESS':
                        availability['title'] = 'Sickness';
                        break;
                    case 'STATUTORY_HOLIDAY':
                        availability['title'] = 'Public/Bank Holiday';
                        break;
                    case 'COMPANY_HOLIDAY':
                        availability['title'] = 'Company Holiday';
                        break;
                    case 'AVAILABILITY':
                        availability['title'] = 'Unavailable';
                        break;
                    case 'WORKABLE':
                        availability['label'] = 'Available';
                        break;
                }
                isRequestInNextDay = availabilityDay === nextDay;
                availability['isAllDay'] = availability['is_all_day'] || availability['all_day'];

                if (['AVAILABILITY', 'WORKABLE'].indexOf(availability['type']) > -1) {
                    if (isRequestInNextDay) {
                        self.nextDayUserRequests['availabilities'][availability['type']] = self.nextDayUserRequests['availabilities'][availability['type']] || [];
                        self.nextDayUserRequests['availabilities'][availability['type']].push(availability);
                    }
                    else {
                        self.currentDayUserRequests['availabilities'][availability['type']] = self.currentDayUserRequests['availabilities'][availability['type']] || [];
                        self.currentDayUserRequests['availabilities'][availability['type']].push(availability);
                    }

                } else {
                    if (isRequestInNextDay) {
                        self.nextDayUserRequests['otherRequests'].push(availability);
                    }
                    else {
                        self.currentDayUserRequests['otherRequests'].push(availability);
                    }

                }
            }
        };

        var getMinorTypeForShift = function () {
            delete self.minorType;
            var userMinorTypes = self.formData.userMinorTypes;
            var startTime = self.data.startTime;

            if (userMinorTypes && userMinorTypes.length) {
                for (var i = 0; i < userMinorTypes.length; i++) {
                    var minorType = userMinorTypes[i];

                    if (
                        moment(startTime).isSameOrAfter(minorType.start_date) &&
                        (!minorType.end_date || moment(startTime).isSameOrBefore(minorType.end_date))
                    ) {
                        return minorType;
                    }

                }
            }
        };

        var getShiftWorkVisaType = function (userWorkVisaTypes, shift) {
            var userVisaType = workVisasService.getShiftVisaType(userWorkVisaTypes, shift);
            if (userVisaType) {
                return userVisaType;
            }
            return null;
        };

        var getUserEmancipatedStatus = function (userId) {
            var startTime = self.data.startTime;
            if (startTime) {
                var allUserEmancipatedStatuses = minorSchedulingService.getUserEmancipationStatuses(userId) || [];
                var emancipatedStatus = minorSchedulingService.getEffectiveMinorUserStatus(allUserEmancipatedStatuses, startTime);
                return emancipatedStatus && emancipatedStatus.is_emancipated;
            }

            return false;
        };

        var getUserRestrictedStatus = function (userId) {
            var startTime = self.data.startTime;
            if (startTime) {
                var allUserRestrictedStatuses = minorSchedulingService.getUserRestrictedStatuses(userId) || [];
                var restrictedStatus = minorSchedulingService.getEffectiveMinorUserStatus(allUserRestrictedStatuses, startTime);
                return restrictedStatus && restrictedStatus.is_restricted;
            }

            return false;
        };

        self.getMinorUserDetailsText = function () {
            let text = $filter("translate")("Minor");

            if (self.hasManageDateOfBirthPermission) {
                text += " " + $filter("translate")("age is") + " " + self.userAge;
            }
            if (self.isEmancipated) {
                text += ", " + $filter("translate")("Emancipated");
            }
            if (self.isRestricted) {
                text += ", " + $filter("translate")("Restricted");
            }
            if (self.minorType && self.isEmancipated && self.isRestricted) {
                text += " " + $filter("translate")("and") + " " + self.minorType.name + " " +$filter("translate")("minor");
            } else if (self.minorType && (!self.isEmancipated || !self.isRestricted)) {
                text += ", " + self.minorType.name + " " + $filter("translate")("minor");
            }
            return text;
        }


        var showMinorDetailsIfMinor = function (userId) {
            var userInfo = userId && TSUsersService.users[userId];
            self.userAge = userInfo && userInfo.getUserAge(self.formData.day);
            if (self.userAge < 18) {
                self.isEmancipated = getUserEmancipatedStatus(userId);
                self.isRestricted = getUserRestrictedStatus(userId);
                self.minorType = getMinorTypeForShift();
            }

        };

        scope.employeeChanged = function (items) {
            var userId = items[0] && items[0].id;

            const userCosts = ScheduleCostsServiceV2.flatData?.costs?.[userId];
            self.isHourlyEmployee = !userId || userCosts?.pay_type?.[self.formData.day]?.type === 'HOURLY';

            if (userId) {
                if (userId === self.formData?.shift?.user_id) {
                    self.data.incentiveDetails.incentiveRule = self.originalIncentiveRule;
                    self.onIncentiveRuleChange();
                } else {
                    self.data.incentiveDetails.incentiveRule = null;
                }
                self.shiftStatus = 'UNPUBLISHED';
                self.user = TSUsersService.users[userId];
                self.showShiftRepeatOptions = !self.user && self.isAssigneeShiftForecastedRecurrenceEnabled;
                if (self.data.role?.code) {
                    const foundPosition = self.data.employee.positions.find(employeePosition => employeePosition.code === self.data.role.code);
                    if (!foundPosition) {
                        self.data.role = self.data.employee.positions[0];
                        self.activeInceniveRules = incentiveOpenShiftPayment.getActiveRulesForPosition(self.activeInceniveRulesMap, self.data.role?.category?.code, self.data.role?.code);
                        scope.roleChanged();
                    }
                }

                if (self.showShiftRepeatOptions) {
                    self.data.forecasted_recurrence = 'ONCE';
                }

                if (self.isMinorRulesEnabled) {
                    showMinorDetailsIfMinor(userId);
                }

                if (self.isWorkRestrictionServiceEnabled && self.user && self.user.hasWorkVisa()) {
                    var usersWorkVisaTypes = workVisasService.usersWorkVisaTypes;
                    self.visaType = getShiftWorkVisaType(usersWorkVisaTypes[userId], self.formData.shift)
                }

                if (self.isJobTitleSkillLevelServiceEnabled) {
                    _jobTitleFuncs.prepareBrandUserJobTitlesListOptions(userId);
                }
                prepareShiftDeservedBreaks(userId, self.data.role);
                prepareEmployeeAvailabilitiesList(userId);
                self.checkMarkedDay(userId);
                checkIfAvailabilityConflicts();
                checkDifferentialPaymentWarning(userId);
                checkIncentiveWarning(userId);
                self.gfeUserIntervals = prepareUserGFEIntervalsForDay(userId, self.formData.day);
                self.originalShiftDetails = getUserPickedUpSwappedShifts(userId, self.formData.shift.id);
                self.isNewlyHiredEmployee = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(self.formData.day, userId, self.data.role);
                self.isNewlyHiredForWeek = fairSchedulingService.isNewlyHiedWithNoPublishSchedule(ScheduleDataServiceV2.startDate, userId, true);
                self.showOptedInVSL = optedInEmployeesMap && self.formData['shift'] && optedInEmployeesMap[self.formData['shift']['id'] + "_" + userId];
                self.formData.userChanged(self.user.id);
                if (self.isScheduledBreaksEnabled && userId) {
                    PerformanceAggregatorAPI.getWaiverOnFileStatus(self.brand.id, userId, moment(ScheduleDataServiceV2.startDate).format('YYYY-MM-DD'))
                        .then(function (res) {
                            self.waiverOnFileBreaks = res?.breaks?.filter(function (waiverBreak) { return waiverBreak.status === 'CONSENTED' }) || [];
                            self.syncScope();
                        })
                }
                self.syncScope();
            } else if (self.data.incentiveDetails && !incentiveOpenShiftPayment.checkIfRuleStillApplyToPosition(self.data.incentiveDetails?.incentiveRule, self.data.role?.category?.code, self.data.role?.code)) {
                self.data.incentiveDetails.incentiveRule = incentiveOpenShiftPayment.getAutomaticAppliedRuleOnPosition(self.automaticeRulesMap, self.data.role.category.code, self.data.role.code)
                self.onIncentiveRuleChange();
            }
        };

        scope.shiftNoteChanged = function () {
            self.shiftStatus = 'UNPUBLISHED';
        };

        self.onHideTimePicker = function (elementClass) {
            setTimeout(function () {
                $("." + formName).find('.' + elementClass).trigger('change');
            }, 500);

            if (currentDay && (((new Date(self.data.endTime).getTime() - new Date(self.data.startTime).getTime()) / (1000 * 60 * 60) ) > 24)) {
                self.data.startTime = setDate(self.data.startTime, currentDay);
                self.data.endTime = setDate(self.data.endTime, currentDay);
                self.formData.shift.end_time = new Date(self.data.endTime).getTime();
                self.formData.shift.start_time = new Date(self.data.startTime).getTime();

                var startOfDay = currentDay;
                var endOfDay = currentDay + 24 * 60 * 60 * 1000;
                if (startOfDay > self.formData.shift.start) {
                    self.formData.shift.actualStart = startOfDay;
                } else {
                    self.formData.shift.actualStart = self.formData.shift.start;
                }

                if (endOfDay < self.formData.shift.end) {
                    self.formData.shift.actualEnd = endOfDay;
                } else {
                    self.formData.shift.actualEnd = self.formData.shift.end;
                }
            }

            if (elementClass === 'shift_start_time')  {
                prepareShiftEndTimeOptions();
            }

            prepareTimeWithinShiftOptions();

            checkIfAvailabilityConflicts();

            if (self.isJobTitleSkillLevelServiceEnabled) {
                var interval = {
                    start_time : self.data.startTime,
                    end_time: self.data.endTime
                }
                _jobTitleFuncs.updateIntervalStartAndEndTime(interval);
                if (self.data.job_titles && self.data.job_titles.length) {
                    _jobTitleFuncs.updateJobTitlesEndTimeOptions();
                }
            }
            prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);

            showMinorDetailsIfMinor();
            checkDifferentialPaymentWarning();
            checkIncentiveWarning();
            self.templateDataChanged();

            self.shiftStatus = 'UNPUBLISHED';
        };

        var updateShiftPartsDetails = function (shift) {
            var shiftParts = {};
            var start = new Date(shift.start_time).getTime();
            var end = new Date(shift.end_time).getTime();
            var isExtendedOverNextDay = ScheduleDataServiceV2.isShiftExtendedOverNextDay(shift);
            var shiftDay = moment(self.formData.day).clone().format('MMM DD, YYYY');
            var extendedDay;

            if (isOvernightShiftSettingsEnabled) {
                if (self.isExtendedFromPreviousDay) {
                    shiftDay = moment(self.formData.day).clone().subtract(1, 'days').format('MMM DD, YYYY');
                    extendedDay = moment(self.formData.day).clone().format('MMM DD, YYYY');
                }
                else if (isExtendedOverNextDay) {
                    extendedDay = moment(self.formData.day).clone().add(1, 'days').format('MMM DD, YYYY');
                }
            }
            shiftParts[shiftDay] = angular.copy(shift);
            shiftParts[shiftDay]['day'] = shiftDay;

            if (
                isOvernightShiftSettingsEnabled &&
                (self.isExtendedFromPreviousDay || isExtendedOverNextDay)
            ) {
                shiftParts[extendedDay] = angular.copy(shift);
                shiftParts[extendedDay]['day'] = shiftDay;
                shiftParts[extendedDay]['extendedDay'] = extendedDay;
                shiftParts[extendedDay]['isExtendedFromPreviousDay'] = true;

                var closeTimeObject = ShiftTemplateUtils.secondsToTimeObj(ScheduleDataServiceV2.dayCloseHour / 1000);
                var shiftEdgeTime = moment(shiftDay).clone().hours(closeTimeObject.hours).minutes(closeTimeObject.minutes);
                var shiftEdgeTimeInMS = shiftEdgeTime.valueOf();

                shiftParts[shiftDay].calculatedStart = start;
                shiftParts[shiftDay].calculatedEnd = shiftEdgeTimeInMS;
                shiftParts[extendedDay].calculatedStart = shiftEdgeTimeInMS;
                shiftParts[extendedDay].calculatedEnd = end;
            }

            else {
                shiftParts[shiftDay].calculatedStart = start;
                shiftParts[shiftDay].calculatedEnd = end;
            }

           return shiftParts;
        };

        const calculateShiftDuration = () => {
            let duration = 0;

            if (self.shiftBasedScheduling && self.shiftIntervals?.length) {
                duration += ShiftTemplateUtils.getIntervalsTotalTime(self.shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
            } else {
                duration += ShiftTemplateUtils.getIntervalsTotalTime([{start_time: self.data.startTime, end_time: self.data.endTime}], ScheduleDataServiceV2.dayOpenHour)
            }

            for (const unpaidBreak of (self.shiftUnpaidBreaks ?? [])) {
                 duration -= unpaidBreak?.duration ?? 0;
            }

            return duration / MINUTE;
        }

        const checkIncentiveWarning = (userId) => {
            userId ??= self.data.employee?.id;
            const userCosts = ScheduleCostsServiceV2.flatData?.costs?.[userId];
            const isHourlyEmployee = userCosts?.pay_type?.[self.formData.day]?.type === 'HOURLY';

            self.isIncenitveWarningShown = false;
            self.incentiveWarningDetails = null;
            if (self.data?.employee?.id === self.formData?.shift?.user_id && incentiveOpenShiftPayment.checkIfRuleStillApplyToPosition(self.data.incentiveDetails?.incentiveRule, self.data.role?.category?.code, self.data.role?.code)) {
                self.isIncenitveWarningShown = self.data?.incentiveDetails?.incentiveRule?.tier_id && isHourlyEmployee;
                self.incentiveWarningDetails = {
                    shiftDuration: calculateShiftDuration(),
                    ruleTitle: self.data.incentiveDetails?.incentiveRule?.name,
                };
                if (self.hasManageHourlyWagesAccess) {
                    let userPositionCosts = userCosts?.[self.data?.role?.code]?.[self.formData.day];

                    const hourCost = parseFloat(userPositionCosts?.rate ?? 0);
                    self.incentiveWarningDetails.amount = incentiveOpenShiftPayment.getIncentiveRuleHourlyAmount(self.data?.incentiveDetails?.incentiveRule, hourCost);
                }

                self.incentiveWarningDetails.description = incentiveOpenShiftPayment
                    .prepareRulePaymentDescription(
                        self.incentiveWarningDetails.ruleTitle,
                        self.incentiveWarningDetails.shiftDuration,
                        $filter('locationCurrencySymbol')(self.brand),
                        self.incentiveWarningDetails.amount,
                        self.hasManageHourlyWagesAccess,
                    );
            }
        };

        var checkDifferentialPaymentWarning = function (employeeId) {
            self.diffrentialPaymentRules = [];
            self.isDiffrentialPaymentWarningMsgShown = false;
            employeeId = employeeId || (self.data.employee && self.data.employee.id);
            var position = self.data.role || {};
            var from;
            var to;

            if (self.shiftBasedScheduling && self.shiftIntervals && self.shiftIntervals.length) {
                from = self.shiftIntervals[0] && self.shiftIntervals[0].start_time && moment(self.shiftIntervals[0].start_time);
                to = self.shiftIntervals[self.shiftIntervals.length - 1] && self.shiftIntervals[self.shiftIntervals.length - 1].end_time && moment(self.shiftIntervals[self.shiftIntervals.length - 1].end_time);
            }
            else {
                from = self.data.startTime;
                to = self.data.endTime;
            }

            var haveAllShiftDataToCalculate =
                position && position.id &&
                employeeId && from && to;

            if (!!haveAllShiftDataToCalculate) {
                var shift = {
                    id: self.formData.shift && self.formData.shift.id,
                    start_time: from,
                    end_time: to,
                    calculatedStart: from.valueOf(),
                    calculatedEnd: to.valueOf(),
                    day: self.formData.day,
                    user_id: employeeId,
                    position: position,
                    unpaidBreaks: self.formData.shift && self.formData.shift.unpaidBreaks,
                };
                var userCosts = ScheduleCostsServiceV2.flatData['costs'][shift.user_id] || {};
                var shiftParts = updateShiftPartsDetails(shift);
                var shiftDays = Object.keys(shiftParts);
                var isUserPayTypeHourly = false;
                var differentialPayRulesForShift = [];

                for (var d in shiftDays) {
                    var shiftPart = shiftParts[shiftDays[d]];
                    var shiftDay = shiftPart['isExtendedFromPreviousDay'] ? shiftPart['extendedDay'] : shiftPart['day'];

                    var userPayTypeForShiftDay =
                        (userCosts["pay_type"] && userCosts["pay_type"][shiftDay]
                            && userCosts["pay_type"][shiftDay]["type"])
                        || 'NONE';
                    isUserPayTypeHourly = isUserPayTypeHourly || (userPayTypeForShiftDay === 'HOURLY');
                    var hour_cost = parseFloat((userCosts
                        && userCosts[position.code]
                        && userCosts[position.code][shiftDay]
                        && userCosts[position.code][shiftDay].rate) || 0);
                    var appliedRules = ScheduleDifferentialPayService.getDifferentialPayForShift(shiftPart, hour_cost);
                    appliedRules = ScheduleCostsServiceV2.getDifferentialPayRulesAccountUnpaidBreaks(shift, appliedRules);

                    for (var r in appliedRules) {
                        var payRuleObject = appliedRules[r];
                        var appliedRuleObj = differentialPayRulesForShift.find(function (rule) {
                            return rule.id === payRuleObject.id;
                        })

                        if (appliedRuleObj) {
                            appliedRuleObj['seconds'] += payRuleObject['seconds'];
                        } else {
                            differentialPayRulesForShift.push(payRuleObject);
                        }
                    }

                }

                if (isUserPayTypeHourly && differentialPayRulesForShift.length > 0) {
                    self.isDiffrentialPaymentWarningMsgShown = true;

                    var currency = $filter("locationCurrencySymbol")(self.brand);

                    for (var i in differentialPayRulesForShift) {
                        var rule = differentialPayRulesForShift[i];
                        var hours = Utils.roundFloat((rule.seconds / 3600), 2);
                        var amount = Utils.roundFloat((rule.amount || 0), 2);
                        var title = rule.title;

                        self.diffrentialPaymentRules.push(
                            incentiveOpenShiftPayment.prepareRulePaymentDescription(
                                title,
                                hours,
                                currency,
                                amount,
                                self.hasManageHourlyWagesAccess,
                            )
                        );
                    }
                }
            }
        };

        var prepareShiftEndTimeOptions = function () {
            if (!self.data.startTime) {
                self.shiftEndTimeOptions = [];
            }
            else {
                var from = moment(self.data.startTime);
                var to = self.businessDayLimits.closeTime;
                if (from.clone().add(1, 'day').isBefore(self.businessDayLimits.closeTime)) {
                    to = from.clone().add(1, 'day');
                }
                self.shiftEndTimeOptions = hTimePickerUtils.getIntervalOptions({
                    from: from,
                    to: to,
                    withInfo: true,
                    minutesPeriod: 15,
                    includeFrom: false,
                    includeTo: true,
                    closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                });
            }
        };

        var prepareTimeWithinShiftOptions = function () {
            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                start_time: self.data.startTime,
                end_time: self.data.endTime
            }];

            var from = shiftIntervals[0] && shiftIntervals[0].start_time && moment(shiftIntervals[0].start_time);
            var to = shiftIntervals[shiftIntervals.length - 1] && shiftIntervals[shiftIntervals.length - 1].end_time && moment(shiftIntervals[shiftIntervals.length - 1].end_time);

            if (from && to) {
                if (from.clone().add(1, 'day').isBefore(to)) {
                    to = from.clone().add(1, 'day');
                }

                const buildTimePickerOptions = (minutesPeriod) => {
                    return hTimePickerUtils.getIntervalOptions({
                        from: from,
                        to: to,
                        withInfo: false,
                        minutesPeriod: minutesPeriod,
                        includeFrom: true,
                        includeTo: false,
                        closeTimeWithoutExtension: self.businessDayLimits.closeTimeWithoutExtension
                    });
                }
                self.timeOptionsWithinShift = buildTimePickerOptions(BREAKS_TIME_PICKER_INTERVAL_PERIOD);
                self.jobTitleStartTimeOptions = buildTimePickerOptions(JOB_TITLES_TIME_PICKER_INTERVAL_PERIOD);
            }
        };

        var setDate = function (date, day) {
            day = moment(day);
            date = moment(date);
            date.day(day.day());
            date.month(day.month());
            date.year(day.year());
            return date._d;
        };

        var prepareShiftTimeFromTemplateIntervals = function () {
            var intervals = businessDayUtils.normalizeTimeIntervals(angular.copy(self.shiftIntervals), ScheduleDataServiceV2.dayOpenHour);
            if(intervals.start_time && intervals.end_time){
                var preparedBreaks = ShiftTemplateUtils.getTimeBreaksObj(intervals, true);
                var period = ShiftTemplateUtils.getPeriod(preparedBreaks["start_time"], preparedBreaks["end_time"], self.formData.day);
                self.data['startTime'] = period.start;
                self.data['endTime'] = period.end;
            }
        };

        var getNormalizedShiftIntervals = function (shiftIntervals, isShiftBasedScheduling, dayOpenHour, selectedDate) {
            var normalizedIntervals = businessDayUtils.normalizeTimeIntervals(angular.copy(shiftIntervals), dayOpenHour);
            if (isShiftBasedScheduling) {
                return normalizedIntervals.map(interval => {
                    const period = ShiftTemplateUtils.getPeriod(interval.start_time / 1000, interval.end_time / 1000, selectedDate);
                    return { start_time: period.start, end_time: period.end };
                });
            } else {
                const startTime = normalizedIntervals[0]?.start_time;
                const endTime = normalizedIntervals[normalizedIntervals.length - 1]?.end_time;
                const period = ShiftTemplateUtils.getPeriod(startTime / 1000, endTime / 1000, selectedDate);

                return [{ start_time: period.start, end_time: period.end }];
            }
        }

        var checkIfAvailabilityConflicts = function () {
            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals : [{
                start_time: self.data.startTime,
                end_time: self.data.endTime
            }];

            if (isValidIntervals(shiftIntervals)) {
                var normalizedShiftIntervals = getNormalizedShiftIntervals(shiftIntervals, self.shiftBasedScheduling, ScheduleDataServiceV2.dayOpenHour, self.formData.day);
                self.shiftAvailabilityConflict = hasConflictWithAvailabilities(normalizedShiftIntervals);
            }
            else if (shiftIntervals.length === 1 && (!shiftIntervals[0]['start_time'] || !shiftIntervals[0]['end_time'])) {
                self.shiftAvailabilityConflict = '';
            }
        }

        var checkIfShiftTimeChanged = function () {
            var shiftIntervals = self.shiftBasedScheduling ? self.shiftIntervals: [{ start_time: self.data.startTime, end_time: self.data.endTime }];
            var intervals = businessDayUtils.normalizeTimeIntervals(shiftIntervals, ScheduleDataServiceV2.dayOpenHour);
            var preparedBreaks = ShiftTemplateUtils.getTimeBreaksObj(intervals, true);
            var period = ShiftTemplateUtils.getPeriod(preparedBreaks["start_time"], preparedBreaks["end_time"], self.formData.day);

            var publishedShiftIntervals = [{start_time: publishedShift.start_time, end_time: publishedShift.end_time}];
            intervals = businessDayUtils.normalizeTimeIntervals(publishedShiftIntervals, ScheduleDataServiceV2.dayOpenHour);
            preparedBreaks = ShiftTemplateUtils.getTimeBreaksObj(intervals, true);
            var publishedPeriod = ShiftTemplateUtils.getPeriod(preparedBreaks["start_time"], preparedBreaks["end_time"], self.formData.day);
            return publishedPeriod.start.getTime() !== period.start.getTime() || publishedPeriod.end.getTime() !== period.end.getTime();
        };

        self.onIntervalTimeChanged = function (changed, validateIndex) {
            setTimeout(function () {
                $("." + formName)
                    .find('[validate-index="' + validateIndex + '"][validate-target="input[name=' + changed + ']"] input[name=' + changed + "]")
                    .trigger('change');
            }, 500);

            prepareShiftTimeFromTemplateIntervals();
            prepareShiftDeservedBreaks(self.data.employee && self.data.employee.id, self.data.role);
            self.breakTimeChanged();
            prepareTimeWithinShiftOptions();
            prepareIntervalTimeOptions(validateIndex, changed);
            checkIfAvailabilityConflicts();
            checkDifferentialPaymentWarning();
            checkIncentiveWarning();
            self.templateDataChanged();
            if (self.isJobTitleSkillLevelServiceEnabled) {
                var startTime = self.shiftIntervals
                    && self.shiftIntervals[0]
                    && self.shiftIntervals[0].start_time;
                var endTime = self.shiftIntervals
                    && self.shiftIntervals[self.shiftIntervals.length - 1]
                    && self.shiftIntervals[self.shiftIntervals.length - 1].end_time;
                _jobTitleFuncs.updateIntervalStartAndEndTime({start_time: startTime, end_time: endTime})
                if (self.data.job_titles && self.data.job_titles.length) {
                    _jobTitleFuncs.updateJobTitlesEndTimeOptions();
                }
            }
        };


        self.restoreShiftConsent = function () {
            self.restoring = true;

            fairSchedulingService.restoreConsent(self.brand.id, self.formData.shift.employee_consent.id, self.data.employee.id)
                .then(function (res) {
                    emitter.trigger(EVENTS.RESTORE_CONSENT, res);
                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.restoring = false;
                    scope.$digest();
                });
        };
    }

    angular
        .module('harriApp')
        .service('SaveShiftForm', ['$modal', 'ShiftTemplateUtils', 'TeamScheduleService', 'businessDayUtils', '$q', '$filter', 'TSUsersService', 'userServices', 'fairSchedulingService', 'goodFaithEstimateService', 'breaksManagementService', 'ScheduleCostsServiceV2', 'breaksAutoAssignService', 'jobTitlesDataService','scheduleDifferentialPayService', 'hEvent', 'userPermissions', 'workVisasService', 'minorSchedulingService', 'useIncentiveOpenShiftPaymentFactory',
            function ($modal, ShiftTemplateUtils, TeamScheduleService, businessDayUtils, $q, $filter, TSUsersService, userServices, fairSchedulingService, goodFaithEstimateService, breaksManagementService, ScheduleCostsServiceV2, breaksAutoAssignService, jobTitlesDataService, ScheduleDifferentialPayService, hEvent, userPermissions, workVisasService, minorSchedulingService, useIncentiveOpenShiftPaymentFactory) {
            return function (scope, ScheduleDataServiceV2, ScheduleWarningServiceV2) {
                return new SaveShiftForm(scope, $modal, ScheduleDataServiceV2, ShiftTemplateUtils, TeamScheduleService, businessDayUtils, $q, $filter, TSUsersService, userServices, fairSchedulingService, goodFaithEstimateService, breaksManagementService, ScheduleCostsServiceV2, breaksAutoAssignService, ScheduleWarningServiceV2, jobTitlesDataService, ScheduleDifferentialPayService, hEvent, userPermissions, workVisasService, minorSchedulingService, useIncentiveOpenShiftPaymentFactory);
            }
        }]);

})(angular, TeamScheduleAPI, ShiftsAPI);
